/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from "jquery";

require('./bootstrap');
require('./jquery.responsivetabs');
require('./rating');

require('spectrum-colorpicker2/dist/spectrum');
require('jquery-mask-plugin');
require('jquery-ui/ui/widgets/autocomplete');
require('bootstrap-datepicker/dist/js/bootstrap-datepicker.min');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min');

import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

if (!Chart._annotationRegistered) {
    Chart.register(...registerables);
    Chart.register(annotationPlugin);
    Chart._annotationRegistered = true;
}

const Tagify = require('@yaireo/tagify');
const SignaturePad = require('signature_pad/dist/signature_pad.umd.min')

import Sortable from 'sortablejs';
import Swal from 'sweetalert2'
import * as moment from 'moment'
import autosize from "autosize/dist/autosize";
window.Vue = require('vue');

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad)

import { BootstrapVue } from 'bootstrap-vue'
import VueStash from 'vue-stash';
Vue.use(BootstrapVue)
Vue.use(VueStash);

import { BarcodeFormat, BrowserBarcodeReader, BrowserMultiFormatReader, DecodeHintType, NotFoundException } from '@zxing/library';

import GenericMultiSelect from './components/GenericMultiSelectComponent';
import QuoteAcceptance from "./components/trade/QuoteAcceptance";
import UsersStatistics from "./components/hr/UsersStatistics";
import TradeEvolution from "./components/trade/TradeEvolution";
import ContractsStatistics from "./components/hr/ContractsStatistics";
import ClientBalance from "./components/trade/ClientBalance";
import ProviderBalance from "./components/spending/ProviderBalance";
import DebtorsRank from "./components/trade/DebtorsRank";
import FiltersSummary from "./components/FiltersSummary";
import Comments from "./components/Comments";
import LineTableForm from "./components/trade/LineTableForm";
import LineForm from "./components/trade/LineForm";
import Sendings from "./components/Sendings";
import BonusSelector from "./components/hr/BonusSelector";
import UserSelector from './components/hr/UserSelector';
import ExpenseReportLineTableForm from "./components/spending/ExpenseReportLineTableForm";
import ExpenseReportLineForm from "./components/spending/ExpenseReportLineForm";
import Signatures from "./components/Signatures";
import SignaturesReceptions from "./components/SignaturesReceptions";
import DocumentsManagerModal from "./components/DocumentsManagerModal";
import DocumentsManager from "./components/DocumentsManager";
import BillPaymentOrderSelector from "./components/bank/BillPaymentOrderSelector";
import AbsencesTable from "./components/hr/AbsencesTable";
import ArticleProviderTableForm from "./components/stock/ArticleProviderTableForm";
import ArticleProviderForm from "./components/stock/ArticleProviderForm";
import ArticleAttributeForm from "./components/stock/ArticleAttributeForm";
import PurchaseTableForm from "./components/spending/PurchaseTableForm";
import PurchaseForm from "./components/spending/PurchaseForm";
import ExpenseBillSelector from "./components/spending/ExpenseBillSelector";
import ArticleSelector from "./components/stock/ArticleSelector";
import CheckingForm from "./components/hr/CheckingForm";
import InitScanCheckingForm from "./components/hr/InitScanCheckingForm";
import CheckingsTable from "./components/hr/CheckingsTable";
import PrecheckingsTable from "./components/hr/PrecheckingsTable";
import PrecheckingsForm from "./components/hr/PrecheckingsForm";
import PredictionTableForm from "./components/trade/PredictionTableForm";
import EditPredictionTable from "./components/trade/EditPredictionTable";
import PredictionForm from "./components/trade/PredictionForm";
import VatsArray from "./components/VatsArray";
import CompanySelector from './components/crm/CompanySelector';
import CompanyPennylaneSync from './components/crm/CompanyPennylaneSync';
import InvoicePennylaneSync from './components/trade/InvoicePennylaneSync';
import CreditNotePennylaneSync from './components/trade/CreditNotePennylaneSync';
import InvoiceValidationModal from './components/trade/InvoiceValidationModal';
import AccountingAccountsAffectation from "./components/bank/AccountingAccountsAffectation";
import TasksTable from "./components/crm/TasksTable";
import SubtasksManager from "./components/crm/SubtasksManager";
import AccountingAccountGeneration from "./components/crm/AccountingAccountGeneration";
import QuickNote from "./components/QuickNote";
import UserNotification from './components/UserNotificationComponent';
import PriceForm from './components/trade/PriceForm';
import AbsencesTableModal from './components/hr/AbsencesTableModal';

import DeliveryLineForm from "./components/activity/DeliveryLineForm";
import DeliveryLineTableForm from "./components/activity/DeliveryLineTableForm";
import DealProgress from "./components/activity/DealProgress";
import OperationTableForm from "./components/activity/OperationTableForm";
import OperationForm from "./components/activity/OperationForm";
import SchedulesKanban from "./components/activity/SchedulesKanban";
import SchedulesSingle from "./components/activity/SchedulesSingle";

import IndicatorsArray from "./components/indicators/IndicatorsArray";

import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import VueUploadComponent from 'vue-upload-component'
import VCalendar from 'v-calendar';
Vue.use(VCalendar);

import Elements from "./components/form_elements/Elements";
import DisplayFormBuilder from "./components/DisplayFormBuilderComponent";
import RenderFormBuilder from './components/RenderFormBuilderComponent';
import PhoneNumber from './components/hr/PhoneNumber';
import BillTotalsForm from './components/spending/BillTotalsForm';
import DealLotOperation from './components/DealLotOperation';
import Note from './components/NoteComponent';
import CustomEditor from './components/CustomEditor';

import SpendingEvolution from "./components/spending/SpendingEvolution";
import BankEvolution from "./components/bank/BankEvolution";
import PaymentComponent from './components/bank/PaymentComponent';
import PayableLine from './components/bank/PayableLine';

import ActivityPies from "./components/activity/ActivityPies";
import Counter from './components/gmao/CounterComponent';
import TriggerComponent from './components/gmao/TriggerComponent';
import PlanningTable from './components/gmao/PlanningTable';
import FormPlanningComponent from './components/gmao/FormPlanningComponent';
import SyncOperation from './components/gmao/SyncOperation';
import CheckingMaintenanceForm from './components/gmao/CheckingMaintenanceForm';
import CreateInspectionComponent from './components/gmao/CreateInspectionComponent';
import PlanningTableModal from './components/gmao/PlanningTableModal';
import DealLotProgress from './components/activity/DealLotProgress';
import GroupOrders from './components/trade/GroupOrders';
import InjectStudy from './components/trade/InjectStudy';
import QuoteVersioning from './components/trade/QuoteVersioning';
import AcceptQuoteVersionning from './components/trade/AcceptQuoteVersionning';
import ServiceListTableForm from './components/trade/ServiceListTableForm';
import ServiceListForm from "./components/trade/ServiceListForm";
import BillCreditSupplierForm from './components/spending/BillCreditSupplierForm';
import BillInboxSidebar from './components/spending/BillInboxSidebar.vue';

import SendingModalComponent from './components/tools/SendingModalComponent';
import TradeStatistics from './components/trade/TradeStatistics';
import ChronoComponent from './components/ChronoComponent';
import DiscountTrade from "./components/trade/DiscountTrade.vue";

import 'leaflet/dist/leaflet.css';
import MapComponent from './components/gmao/MapComponent';
import BookingLotArticleForm from "./components/activity/BookingLotArticleForm.vue";
import BookingArticleLine from "./components/activity/BookingArticleLine.vue";
import BookingLotArticleLine from "./components/activity/BookingLotArticleLine.vue";
import BookingModal from "./components/activity/BookingModal.vue";
import ArticleProgressStock from "./components/stock/ArticleProgressStock.vue";
import BookingArticleTable from "./components/stock/BookingArticleTable.vue";
import ArticleEcoTaxForm from "./components/stock/ArticleEcoTaxForm.vue";
import ArticleDealsSummary from "./components/stock/ArticleDealsSummary.vue";
import ReceptionsValuationSummary from "./components/spending/ReceptionsValuationSummary.vue";

import AutoFormSaveComponent from './components/AutoFormSaveComponent.vue';

import EquipmentStationTable from "./components/activity/EquipmentStationTable.vue";
import PrecheckingsInterventionForm from "./components/hr/PrecheckingsInterventionForm.vue";
import PrecheckingsInterventionTable from "./components/hr/PrecheckingsInterventionTable.vue";
import GroupDeliveries from "./components/activity/GroupDeliveries.vue";


import Fragment from 'vue-fragment';
Vue.use(Fragment.Plugin);

Vue.component('file-upload', VueUploadComponent);
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
const API_TOKEN = document.head.querySelector("[name~=api-token][content]").content;
const CSRF_TOKEN = document.head.querySelector("[name~=csrf-token][content]").content;

const COLOR_PRIMARY = "#d9523b";
const COLOR_BLUE = "#077FD4";
const COLOR_LIGHT = "#F6F6F6";

window.addEventListener('pageshow', PageShowHandler, false);
window.addEventListener('unload', UnloadHandler, false);

moment.locale('fr');

function PageShowHandler() {
    window.addEventListener('unload', UnloadHandler, false);
}

function UnloadHandler() {
    window.removeEventListener('unload', UnloadHandler, false);
}

$(function () {

    // Masquer la colonne % si le type de facture n'est pas "Facture" (type 0)
    const initialType = $('#type').val();
    if (initialType && initialType != "0") {
        $('.percentage-field').hide();
    }

    // Mot de passe en clair (accès tiers)
    $('#show-btn-password span').on('click', function (e) {
        e.preventDefault();
        if ($('#show-btn-password input').attr('type') == 'text') {
            $('#show-btn-password input').attr('type', 'password');
            $('#show-btn-password i').addClass("fa-eye-slash");
            $('#show-btn-password i').removeClass("fa-eye");
        } else if ($('#show-btn-password input').attr('type') == 'password') {
            $('#show-btn-password input').attr('type', 'text');
            $('#show-btn-password i').addClass("fa-eye");
            $('#show-btn-password i').removeClass("fa-eye-slash");
        }
    });

    /**
     * Règles de mot de passe dynamiques
     *
     * HTML attendu :
     * <div class="js-password-rules" data-password-input="#password">
     *   <li class="password-rule" data-rule="length">...</li>
     *   <li class="password-rule" data-rule="lowercase">...</li>
     *   <li class="password-rule" data-rule="uppercase">...</li>
     *   <li class="password-rule" data-rule="number">...</li>
     *   <li class="password-rule" data-rule="special">...</li>
     * </div>
     */
    function initPasswordRules() {
        var $blocks = $('.js-password-rules');
        if ($blocks.length === 0) {
            return;
        }

        $blocks.each(function () {
            var $block = $(this);
            var selector = $block.data('password-input') || '#password';
            var $input = $(selector);

            if ($input.length === 0) {
                return;
            }

            var $rules = {
                length: $block.find('[data-rule="length"]'),
                lowercase: $block.find('[data-rule="lowercase"]'),
                uppercase: $block.find('[data-rule="uppercase"]'),
                number: $block.find('[data-rule="number"]'),
                special: $block.find('[data-rule="special"]'),
            };

            function updatePasswordRules() {
                var value = $input.val() || '';

                var length = value.length;
                var hasLowercase = /[a-z]/.test(value);
                var hasUppercase = /[A-Z]/.test(value);
                var hasNumber    = /[0-9]/.test(value);
                // Compatible tous navigateurs : on considère "spécial" = pas lettre ASCII ni chiffre
                var hasSpecial = /[!@#$%^&*()_\-+=[\]{};:'"\\|,.<>\/?]/.test(value);

                toggleRule($rules.length, length >= 12);
                toggleRule($rules.lowercase, hasLowercase);
                toggleRule($rules.uppercase, hasUppercase);
                toggleRule($rules.number, hasNumber);
                toggleRule($rules.special, hasSpecial);
            }

            function toggleRule($el, isValid) {
                if (!$el || $el.length === 0) {
                    return;
                }

                var $icon = $el.find('i').first();

                if (isValid) {
                    $el.removeClass('text-muted text-danger').addClass('text-success');
                    if ($icon.length) {
                        $icon.removeClass('fa-circle fa-times').addClass('fa-check');
                    }
                } else {
                    $el.removeClass('text-success text-danger').addClass('text-muted');
                    if ($icon.length) {
                        $icon.removeClass('fa-check fa-times').addClass('fa-circle');
                    }
                }
            }

            // Initialisation et écoute des changements
            updatePasswordRules();

            $input.on('input', updatePasswordRules);
        });
    }

    initPasswordRules();

    // Copie dans le presse-papiers lors du clic sur un élément texte
    // HTML attendu :
    // <span class="js-copy-on-click" data-copy-text="...">Texte à copier</span>
    $(document).on('click', '.js-copy-on-click', function () {
        var text = $(this).data('copy-text') || $(this).text();

        if (!text) {
            return;
        }

        function notify(message) {
            alert(message);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(function () {
                notify('Lien copié dans le presse-papiers');
            }).catch(function () {
                notify('Impossible de copier le lien automatiquement');
            });
        } else {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(text).select();
            try {
                document.execCommand('copy');
                notify('Lien copié dans le presse-papiers');
            } catch (e) {
                notify('Impossible de copier le lien automatiquement');
            }
            $temp.remove();
        }
    });

    // Mot de passe en clair (tous les champs avec .js-toggle-password dans un input-group)
    $('.js-toggle-password').on('click', function (e) {
        e.preventDefault();
        var $group = $(this).closest('.input-group');
        if ($group.length === 0) return;

        var $input = $group.find('input[type="password"], input[type="text"]').first();
        if ($input.length === 0) return;

        var $icon = $(this).find('i');

        if ($input.attr('type') === 'password') {
            $input.attr('type', 'text');
            if ($icon.length) {
                $icon.removeClass('fa-eye').addClass('fa-eye-slash');
            }
        } else {
            $input.attr('type', 'password');
            if ($icon.length) {
                $icon.removeClass('fa-eye-slash').addClass('fa-eye');
            }
        }
    });

    if($('#due_at').length > 0 && $('#payment_delay_id').length > 0 && $('#validated_at').length > 0 && $('#due_at').val() != null && $('#due_at').val() != '' && $('#validated_at').val() != null && $('#validated_at').val() != ''){
        $('#payment_delay_id, #validated_at').on('change', function() {
            var validatedDate = $('#validated_at').val();
            var originalDate = moment(validatedDate, "DD/MM/YYYY");
            var copyDate = originalDate.clone(); // Clone the original date for each calculation
            switch ($('#payment_delay_id').val()) {
                case "2": // 30 jours
                    copyDate.add(30, 'days');
                    break;
                case "3": // 45 jours
                    copyDate.add(45, 'days');
                    break;
                case "4": // 60 jours
                    copyDate.add(60, 'days');
                    break;
                case "5": // 30 jours fin de mois
                    copyDate.add(30, 'days').endOf('month');
                    break;
                case "6": // 45 jours fin de mois
                    copyDate.add(45, 'days').endOf('month');
                    break;
                case "7": // 45 jours fin de mois
                    copyDate.add(60, 'days').endOf('month');
                    break;
                default:
                    copyDate = originalDate.clone(); // Reset to original date if no valid option is selected
                    break;
            }

            $('#due_at').val(copyDate.format('DD/MM/YYYY'));
        });
    }
    

    $('.js-toggle-dark-mode').click(function (e) {
        e.preventDefault();
        $('body').toggleClass('dark-theme');
    });

    $('.nav-tabs').responsiveTabs();

    $(window).scroll(function () {
        if ($(window).scrollTop() >= 150) {
            $('.js-ix-page-header').addClass('fixed');
        }
        else {
            $('.js-ix-page-header').removeClass('fixed');
        }
    });

    const menuToggle = $('#ix-menu-toggle');
    const menuDropdown = $("#ix-menu-dropdown");
    const notificationsPanel = $("#ix-notifications-panel");

    $('#ix-menu-toggle').on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        $('#ix-menu-dropdown').toggleClass('open')
    });

    $(document).click(function (e) {
        // If the target of the click isn't the container
        if ((!menuDropdown.is(e.target) && menuDropdown.has(e.target).length === 0) || (!menuToggle.is(e.target) && menuToggle.has(e.target).length === 0)) {
            menuDropdown.removeClass('open');
        }

        if ($(".ix-menu-notification-item").has(e.target).length === 0 && notificationsPanel.hasClass('open')) {
            notificationsPanel.removeClass('open')
        }

        if ($('.ix-sidebar.open').length && !$('.ix-sidebar.open').is(e.target) && $('.ix-sidebar.open').has(e.target).length === 0 && !$('.trigger-sidebar').is(e.target) && $('.trigger-sidebar').has(e.target).length === 0 && !$('.swal-overlay').is(e.target) && $('.swal-overlay').has(e.target).length === 0 && !$('.swal2-container').is(e.target) && $('.swal2-container').has(e.target).length === 0 
             && !$('.ui-menu-item-wrapper').is(e.target) && // Remplacez '.autocomplete-element' par la classe de votre élément d'autocomplétion
            $('.ui-menu-item-wrapper').has(e.target).length === 0) {
            $('.ix-sidebar.open').removeClass('open')
        }
    });

    let scrollTo = $('body').data('scroll-to');
    if (scrollTo != undefined) {
        scrollToAnchor(scrollTo)
    }

    /**
     * Gestion des permissions a désactiver en cascade
     */
    $('.checkbox-permission').change(function () {
        var permissions = $(this).data('permissions-to-disable');
        if (permissions != "" && $(this).is(':checked')) {
            permissions = permissions.split(';');
            permissions.forEach(permission => {
                $("#" + permission).prop("checked", false);
            })
        }

    })

    /**
     * Gestion de l'unité du tarif écoparticipation
     * Met à jour l'unité affichée selon le mode de calcul sélectionné
     */
    function updateEcoRateUnit() {
        var calculationMode = $('#calculation_mode').val();
        var unitDisplay = $('#eco-rate-unit');

        if (unitDisplay.length === 0) {
            return; // L'élément n'existe pas sur cette page
        }

        if (calculationMode === 'weight') {
            unitDisplay.text('€ / kg');
        } else {
            unitDisplay.text('€ / unité');
        }
    }

    // Initialisation au chargement de la page
    updateEcoRateUnit();

    // Mise à jour quand le mode de calcul change
    $(document).on('change', '#calculation_mode', function () {
        updateEcoRateUnit();
    });

    autosize(document.querySelectorAll('textarea'));

    $(".color-picker").spectrum({
        locale: "fr",
        type: "text",
        showAlpha: false,
        showInitial: true,
        preferredFormat: "hex"
    });

    $('.delete-form').on('submit', confirmDelete);
    $('.duplicate-form').on('submit', confirmDuplicate);
    $('.accept-quotes').on('click', confirmAcceptCreateQuote);
    $('.delete-link').on('click', confirmDelete);
    $('.confirm-form').on('submit', confirmForm);
    $('.confirm-form-deal-unclosed').on('click', confirmFormDealUnClosed);
    $('.close-form').on('click', confirmCloseInspection);
    $('.delete-form-preventive').on('click', confirmDeletePreventive);

    $('.confirm-payment').on('submit', function (e) {
        e.preventDefault();
        var amount = formatCurrency($('#' + $(this).data('amount-input')).val())

        Swal.fire({
            title: amount,
            text: "Confimez-vous le montant renseigné ?",
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Corriger',
            confirmButtonText: 'Confirmer',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.value) {
                disableSubmitButton(this)
                this.submit()
            }
        })
    })

   /* var studyForm = document.getElementById('study-create-form');
    if (studyForm) {
      var timerId = null;
    
      var validateStudyFormRequired = function() {
        var missing = [];
        var requiredFields = studyForm.querySelectorAll('[required]');
        requiredFields.forEach(function(el) {
          var value = (el.value || '').trim();
          if (!value) {
            var label = '';
            if (el.id) {
                // lots[0][designation]
//lots[0][unit]
              var labelEl = studyForm.querySelector('label[for="'+el.id+'"]');
              if (labelEl) label = labelEl.textContent.trim();
            }
            if (!label && el.name) label = el.name;
            missing.push(label || 'Champ requis');
          }
        });
        return missing;
      };
    
      function schedulePrompt() {
        timerId = setTimeout(function() {
          Swal.fire({
            title: "Enregistrer l'étude ?",
            text: "Souhaitez-vous enregistrer l'étude maintenant ?",
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Non',
            confirmButtonText: 'Oui',
            reverseButtons: true,
            heightAuto: false
          }).then(function(result) {
            if (result && (result.value || result.isConfirmed)) {
              var missing = validateStudyFormRequired();
              if (missing.length > 0) {
                Swal.fire({
                  title: 'Champs obligatoires manquants',
                  html: "<p>Veuillez renseigner les champs obligatoires avant l'enregistrement</p>",
                  icon: 'warning',
                  confirmButtonText: 'OK',
                  heightAuto: false
                }).then(function() {
                  schedulePrompt(); // reprogrammer après le message
                });
                } else {
                    // Ajouter le paramètre de redirection pour l'enregistrement automatique
                    var formAction = studyForm.action;
                    studyForm.action = formAction + '?redirect=edit';
                    studyForm.submit();
                }
            } else {
              schedulePrompt(); // reprogrammer si l'utilisateur annule
            }
          });
        }, 10000);
      }
    
      schedulePrompt();
    
      studyForm.addEventListener('submit', function() {
        if (timerId) clearTimeout(timerId);
      });
    }*/

    $('.finish-inspection-form').on('click', function (event) {
        event.preventDefault();
        Swal.fire({
            title: "Etes-vous sûr ?",
            text: "La femeture de l'ordre de travail entrainera la mise à jour des déclencheurs de la gamme opératoire associée. Il ne sera plus possible de modifier le contenu de l'ordre de travail. ?",
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonText: 'Confirmer',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.value) {
                disableSubmitButton(this)
                this.submit()
            }
        })
    });

    // Saisie raison du refus d'un devis avant soumission
    $('.refuse-quote-form').on('submit', function (e) {
        e.preventDefault()
        Swal.fire({
            title: 'Indiquez la raison du refus',
            input: 'textarea',
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonText: 'Refuser',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.hasOwnProperty('value')) {
                $('#refuse-reason').val(result.value)
                disableSubmitButton(this)
                this.submit()
            }
        })
    })

    // Affectation affaire ou non dans acceptation devis
    $('input[type=radio][name=create_new_deal]').change(function () {
        let value = this.value
        if (value == '1') {
            $('#deal_label').prop('readonly', true)
            $('#deal_new_name').prop('readonly', false)
            $('#deal_new_name').prop('required', true)
        } else if (value == '2') {
            $('#deal_label').prop('readonly', true)
            $('#deal_new_name').prop('readonly', true)
            $('#deal_new_name').prop('required', false)
        } else {
            $('#deal_label').prop('readonly', false)
            $('#deal_new_name').prop('readonly', true)
            $('#deal_new_name').prop('required', false)
        }
    });

    // Chagement route autocomplete lors du choix d'un objet de paiement
    $('#payment_payable_type').on('change', function (e) {
        let opt = $("option:selected", this);
        let apiUrl = opt.data('api-url');

        // reset champs autocomplete et changement url api
        $('#payment_payable_label').data('api-url', apiUrl)
        $('#payable_api_url').val(apiUrl)
        $('#payment_payable_label').val('')
        $('#payment_payable_id').val('')
    });


    // Remove invalid class on input on blur
    $(".is-invalid").change(function () {
        $(this).removeClass('is-invalid');
    });

    $('[data-toggle="tooltip"]:not(.copy-button)').tooltip();
    $('.toast').toast('show');

    window.showToast = function(message, type) {
        type = type || 'success';
        var cssClass = type === 'error' ? 'ix-toast-error' : 'ix-toast-success';
        var $toast = $('<div class="toast" style="position: absolute; top: 10px; right: 105px;" data-delay="4000"></div>');
        if (type === 'error') {
            $toast.attr('data-autohide', 'false').removeAttr('data-delay');
        }
        $toast.html(
            '<div class="ix-toast ' + cssClass + '">' +
            message +
            '<button type="button" class="close" data-dismiss="toast" aria-label="Close">' +
            '<span aria-hidden="true"><i class="far fa-times"></i></span>' +
            '</button></div>'
        );
        $('body').append($toast);
        $toast.toast('show');
        $toast.on('hidden.bs.toast', function() { $(this).remove(); });
    };

    $('#tagsTabs a:first').tab('show');

    $('.datepicker').each(function (i, el) {
        el = $(el);

        var datepickerOptions = {
            format: "dd/mm/yyyy",
            todayBtn: true,
            language: "fr",
            calendarWeeks: true,
            autoclose: true,
            todayHighlight: true,
        }

        el.datepicker(datepickerOptions);

        el.change(function () {
            $(this)[0].dispatchEvent(new Event('input'));
        });
    })


    $('.datepicker').on('change', function () {
        var targetMin = $(this).data('set-min')
        if (targetMin) {
            $('#' + targetMin).datepicker('setStartDate', $(this).val());
        }

        var targetMax = $(this).data('set-max')
        if (targetMax) {
            $('#' + targetMax).datepicker('setEndDate', $(this).val());
        }
    });

    $('#warranty_cap_inactive').change(function () {
        if ($("#warranty_cap").length) {
            $("#warranty_cap").val("");
            if ($(this).prop('checked')) {
                $("#warranty_cap").prop("disabled", true);
            } else {
                $("#warranty_cap").prop("disabled", false);
            }
        }
    });

    $('.siren-mask').mask('000 000 000', { placeholder: "___ ___ ___" });
    $('.siret-mask').mask('000 000 000 00000', { placeholder: "___ ___ ___ _____" });
    $('.social-security-mask').mask('0 00 00 00 000 000 00', { placeholder: "_ __ __ __ ___ ___ __" });
    $('.code_validy').mask('A A A A A A A A', { placeholder: "_ _ _ _ _ _ _ _"});

    $('#ape_code').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/api/ape_codes',
                type: 'get',
                dataType: 'json',
                headers: getHeaders(),
                data: { q: request.term, maxResults: 10 },
                success: function (data) {
                    response($.map(data, function (item) {
                        return {
                            code: item.code,
                            label: item.full_label,
                            short_label: item.label,
                            value: item.code
                        }
                    }))
                }
            });
        },
        select: function (e, item) {
            if ($("#ape_label").length) {
                $("#ape_label").val(item.item.short_label)
            }
        }
    });

    $('#ape_label').autocomplete({
        source: function (request, response) {
            $.ajax({
                url: '/api/ape_codes',
                type: 'get',
                dataType: 'json',
                headers: getHeaders(),
                data: { q: request.term, maxResults: 10 },
                success: function (data) {
                    response($.map(data, function (item) {
                        return {
                            code: item.code,
                            label: item.full_label,
                            short_label: item.label,
                            value: item.label
                        }
                    }))
                }
            });
        },
        select: function (e, item) {
            if ($("#ape_code").length) {
                $("#ape_code").val(item.item.code)
            }
        }
    });

    /**
     * Instanciation des différents autocomplete
     */
    if ($('.company-autocomplete').length) {
        $('.company-autocomplete').autocomplete(initAutocompleteWithParams($('.company-autocomplete'))).focus(function () {
            $(this).autocomplete("search", '');
        });
    }

    if ($('.user-autocomplete').length) {
        $('.user-autocomplete').autocomplete(initAutocompleteWithParams($('.user-autocomplete'))).focus(function () {
            $(this).autocomplete("search", '');
        });
    }

    if ($('.capacitation-autocomplete').length) {
        $('.capacitation-autocomplete').autocomplete(initAutocompleteWithParams($('.capacitation-autocomplete'))).focus(function () {
            $(this).autocomplete("search", '');
        });
    }

    /**
    * Champs autocomplete variable
    * Ce module permet d'obtenir une auto complétion sur un models demandé. Il est utilisable comme "select" déguisé ou pour permettre la création à la volé d'élément
    * data-label : Clé affiché dans les suggestions
    * data-value : Clé affiché dans l'input après selection
    * data-filters : Filtres supplémentaires à appliquer, ex: data-filters='{ "under_contract": 1}'
    */
    function initAutocompleteWithParams(instance) {
        let modelAutocompleteForceValue = instance.data("force-value");
        let modelAutocompleteUrl = instance.data("api-url");
        let modelAutocompleteLabel = instance.data("label");
        let modelAutocompleteValue = instance.data("value");
        let modelAutocompleteTargetInputId = $('#' + instance.data("target-input-id"));

        // Construction des filtres
        var modelAutocompleteFilters = instance.data("filters");
        if (modelAutocompleteFilters == undefined) {
            modelAutocompleteFilters = {};
        }

        return {
            source: function (request, response) {
                $.ajax({
                    url: modelAutocompleteUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: getHeaders(),
                    data: { ...{ q: request.term }, ...modelAutocompleteFilters },
                    success: function (data) {
                        response($.map(data, function (item) {
                            return {
                                id: item.id,
                                label: item[modelAutocompleteLabel],
                                value: item[modelAutocompleteValue]
                            }
                        }))
                    }
                });
            },
            minLength: 0,
            change: function (event, item) {
                // Si la valeur n'est pas selectionnée dans les suggestions (saisie libre)
                if (!item.item) {
                    // Si l'on demande obligatoirement une valeur dans les suggestions, reset de la valeur du champs
                    if (modelAutocompleteForceValue == true) {
                        $(event.target).val("");
                    }

                    // Dans tous les cas, reset du champs associé pour éviter qu'un ID non correct soit envoyé
                    if (modelAutocompleteTargetInputId.length) {
                        modelAutocompleteTargetInputId.val("")
                    }
                }
            },
            focus: function (event, ui) {
                return false;
            },
            select: function (e, item) {
                if (modelAutocompleteTargetInputId.length) {
                    modelAutocompleteTargetInputId.val(item.item.id)
                }
            }
        }
    }


    /** 
     * Autocomplete lors de la création d'une société
     * Permet de consulter les sociétés déjà existantes
     */
    $('#autocomplete_company_name').autocomplete({
        minLength: 0,
        source: function (request, response) {
            $.ajax({
                url: $('#autocomplete_company_name').data("api-url"),
                type: 'get',
                dataType: 'json',
                headers: getHeaders(),
                data: { ...{ q: request.term } },
                success: function (data) {
                    response($.map(data, function (item) {
                        return Object.assign(item, {
                            label: item['name'] ?? '',
                            value: item['name'] ?? '',
                        })
                    }))
                }
            });
        },
    })

    /**
     * Achats directs de l'affaire (onglet Achats) : un fournisseur, plusieurs lignes
     * - désignation : articles et leurs prix par fournisseur (filtrés sur le fournisseur choisi), comme les commandes
     *   fournisseurs ; un prix choisi remplit le PU HT ; saisie libre possible (aucun article rattaché)
     * - lignes ajoutées en clonant la première, retirées (au moins une reste), totaux recalculés à la saisie
     */
    $('.ix-direct-purchase-form').each(function (i, form) {
        form = $(form);
        var lines = form.find('.js-direct-purchase-lines');
        var nextIndex = lines.find('.js-direct-purchase-line').length;
        var escapeHtml = function (value) {
            return $('<div>').text(value === null || value === undefined ? '' : String(value)).html();
        };
        var formatCurrency = function (value) {
            return (parseFloat(value) || 0).toLocaleString('fr-FR', {style: 'currency', currency: 'EUR'});
        };

        var computeTotals = function () {
            var grandTotal = 0;
            lines.find('.js-direct-purchase-line').each(function () {
                var row = $(this);
                var total = Math.round((parseFloat(row.find('.js-direct-purchase-quantity').val()) || 0) * (parseFloat(row.find('.js-direct-purchase-amount').val()) || 0) * 100) / 100;
                row.find('.js-direct-purchase-total').text(formatCurrency(total));
                grandTotal += total;
            });
            form.find('.js-direct-purchase-grand-total').text(formatCurrency(grandTotal));
        };

        // Article du stock lié à la ligne : icône devant la désignation
        var refreshArticle = function (row) {
            row.find('.js-direct-purchase-article-icon').toggle(!!row.find('.js-direct-purchase-article').val());
        };

        var initLine = function (row) {
            var designation = row.find('.js-direct-purchase-designation');
            designation.data('article-label', row.find('.js-direct-purchase-article').val() ? designation.val() : null);
            refreshArticle(row);

            // Désignation modifiée à la main après le choix d'un article : la ligne n'est plus liée à l'article
            designation.on('input', function () {
                if (row.find('.js-direct-purchase-article').val() && designation.val() !== designation.data('article-label')) {
                    row.find('.js-direct-purchase-article').val('');
                    refreshArticle(row);
                }
            });

            designation.autocomplete({
                minLength: 2,
                source: function (request, response) {
                    $.ajax({
                        url: lines.data('suggestions-url'),
                        type: 'get',
                        dataType: 'json',
                        headers: getHeaders(),
                        data: {q: request.term, company_id: form.find('#direct_purchase_company_id').val()},
                        success: function (data) {
                            response($.map(data, function (item) {
                                return Object.assign(item, {label: item.designation, value: item.designation});
                            }));
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var html = item.provider !== null
                            ? '<div class="d-flex align-items-center ix-text-small ix-suggestion-small"><span><i class="far fa-level-up fa-rotate-90"></i> Vendu par ' + escapeHtml(item.provider)
                                + (item.is_favorite ? ' <span class="ix-text-yellow"><i class="far fa-star"></i></span>' : '')
                                + (item.reference ? ' - ' + escapeHtml(item.reference) : '') + (item.indications ? ' - ' + escapeHtml(item.indications) : '')
                                + '</span><span class="ml-auto">' + formatCurrency(item.amount) + '</span></div>'
                            : '<div class="d-flex align-items-center"><span>' + escapeHtml(item.designation) + '</span><span class="ml-auto">' + escapeHtml(item.number || '') + '</span></div>';

                        return $('<li>').append(html).appendTo(ul);
                    };
                },
                change: function (event, ui) {
                    if (!ui.item) {
                        row.find('.js-direct-purchase-article').val('');
                        refreshArticle(row);
                    }
                },
                select: function (event, ui) {
                    row.find('.js-direct-purchase-article').val(ui.item.article_id);
                    designation.data('article-label', ui.item.value);
                    refreshArticle(row);
                    if (ui.item.unit) {
                        row.find('.js-direct-purchase-unit').val(ui.item.unit);
                    }
                    // Prix du fournisseur choisi : injecté dans le PU HT, le total HT suit
                    if (ui.item.amount !== null && ui.item.amount !== undefined) {
                        row.find('.js-direct-purchase-amount').val(ui.item.amount);
                        computeTotals();
                    }
                }
            });
        };

        // Choix du lot : texte d'invite en gris tant qu'aucun lot n'est choisi, nom complet (et étude) au survol
        var refreshLot = function (select) {
            var option = select.find('option:selected');
            var group = option.parent('optgroup').attr('label');
            select.toggleClass('is-empty', !select.val());
            if (!select.prop('disabled')) {
                select.attr('title', select.val() ? option.text() + (group ? ' — ' + group : '') : 'Lot facultatif');
            }
        };

        lines.find('.js-direct-purchase-line').each(function () {
            initLine($(this));
            refreshLot($(this).find('.js-direct-purchase-lot'));
        });

        lines.on('change', '.js-direct-purchase-lot', function () {
            refreshLot($(this));
        });

        lines.on('input', '.js-direct-purchase-quantity, .js-direct-purchase-amount', computeTotals);

        // Nouvelle ligne : copie vierge de la première, lot et nature repris de la ligne précédente
        form.on('click', '.js-direct-purchase-add-line', function () {
            var last = lines.find('.js-direct-purchase-line').last();
            var row = lines.find('.js-direct-purchase-line').first().clone();
            var index = nextIndex++;

            row.find('.ui-autocomplete-input').removeClass('ui-autocomplete-input').removeAttr('autocomplete');
            row.find('.is-invalid').removeClass('is-invalid');
            row.find('input, select').each(function () {
                this.name = this.name.replace(/^lines\[[^\]]*\]/, 'lines[' + index + ']');
            });
            row.find('input[type="text"], input[type="hidden"]').val('');
            row.find('.js-direct-purchase-amount').val('');
            row.find('.js-direct-purchase-quantity').val(1);
            row.find('select').each(function () {
                $(this).val(last.find('select[name$="[' + this.name.split('[').pop()).val());
            });

            lines.append(row);
            initLine(row);
            refreshLot(row.find('.js-direct-purchase-lot'));
            computeTotals();
            row.find('.js-direct-purchase-designation').focus();
        });

        // Retrait d'une ligne : au moins une ligne reste
        form.on('click', '.js-direct-purchase-remove-line', function () {
            if (lines.find('.js-direct-purchase-line').length > 1) {
                $(this).closest('.js-direct-purchase-line').remove();
            } else {
                var row = $(this).closest('.js-direct-purchase-line');
                row.find('input[type="text"], input[type="hidden"], .js-direct-purchase-amount').val('');
                row.find('.js-direct-purchase-quantity').val(1);
                refreshArticle(row);
            }
            computeTotals();
        });

        // Fournisseur saisi librement (absent de la liste) : signalé comme nouveau, créé à l'enregistrement
        var companyName = form.find('.js-direct-purchase-company');
        var companyId = form.find('#direct_purchase_company_id');
        var refreshNewCompany = function () {
            form.find('.js-direct-purchase-new-company').toggle(!!$.trim(companyName.val()) && !companyId.val());
        };
        companyId.on('change', refreshNewCompany);
        companyName.on('blur', function () { setTimeout(refreshNewCompany, 0); });
        companyName.on('input', function () { form.find('.js-direct-purchase-new-company').hide(); });
        refreshNewCompany();

        // Justificatifs : chaque choix s'ajoute aux précédents ; chaque fichier se retire par sa pastille
        var documentFiles = new DataTransfer();
        var documentInput = form.find('.js-direct-purchase-document-pick');
        var renderDocuments = function () {
            var list = form.find('.js-direct-purchase-document-list').empty();
            Array.from(documentFiles.files).forEach(function (file, position) {
                var name = file.name.length > 22 ? file.name.substr(0, 20) + '…' : file.name;
                var chip = $('<span class="ix-direct-purchase-document-chip">').attr('title', file.name)
                    .append($('<i class="far">').addClass(/^image\//.test(file.type) ? 'fa-file-image' : 'fa-file-pdf'))
                    .append($('<span>').text(name))
                    .append($('<button type="button" class="js-direct-purchase-document-remove" title="Retirer">&times;</button>').data('position', position));
                list.append(chip);
            });
            documentInput[0].files = documentFiles.files;
        };

        form.on('change', '.js-direct-purchase-document-pick', function () {
            Array.from(this.files).forEach(function (file) {
                var already = Array.from(documentFiles.files).some(function (existing) {
                    return existing.name === file.name && existing.size === file.size;
                });
                if (!already) {
                    documentFiles.items.add(file);
                }
            });
            renderDocuments();
        });

        form.on('click', '.js-direct-purchase-document-remove', function () {
            documentFiles.items.remove($(this).data('position'));
            renderDocuments();
        });

        computeTotals();
    });

    /**
     * Champs autocomplete variable
     * Ce module permet d'obtenir une auto complétion sur un models demandé. Il est utilisable comme "select" déguisé ou pour permettre la création à la volé d'élément
     * data-label : Clé affiché dans les suggestions
     * data-value : Clé affiché dans l'input après selection
     * data-filters : Filtres supplémentaires à appliquer, ex: data-filters='{ "under_contract": 1}'
     */
    $('input.model-autocomplete').each(function (i, el) {
        el = $(el);
        el.autocomplete({
            minLength: 0,
            source: function (request, response) {
                $.ajax({
                    url: el.data("api-url"),
                    type: 'get',
                    dataType: 'json',
                    headers: getHeaders(),
                    data: { ...{ q: request.term }, ...el.data("filters") === undefined ? {} : el.data("filters") },
                    success: function (data) {
                        response($.map(data, function (item) {
                            return Object.assign(item, {
                                label: item[el.data("label")] ?? '',
                                value: item[el.data("value")] ?? '',
                            })
                        }))
                    }
                });
            },
            change: function (event, item) {
                const fn = el.data("extra-fn");
                // Si la valeur n'est pas selectionnée dans les suggestions (saisie libre)
                if (!item.item) {
                    // Si l'on demande obligatoirement une valeur dans les suggestions, reset de la valeur du champs
                    if (el.data("force-value") == true) {
                        $(event.target).val("");
                    }

                    // Dans tous les cas, reset du champs associé pour éviter qu'un ID non correct soit envoyé
                    if ($('#' + el.data("target-input-id")).length) {
                        $('#' + el.data("target-input-id")).val("").change();
                    }
                }

                // Traitement supplémentaire
                if (fn == 'fillLotFromMovement') {
                    if (item.item != null) {
                        if (item.item.lots.length >= 1) {
                            $('#lot_label').removeAttr('disabled');
                        } else {
                            $('#lot_label').attr('disabled', true);
                        }
                    }
                }

                if(fn == 'fillDealContactMission'){
                    if(item.item && item.item.contact){
                        if(item.item.contact.gender !== null && item.item.contact.gender !== undefined) {
                            $('input[name="gender"][value="' + item.item.contact.gender + '"]').prop('checked', true);
                        }

                        $('#firstname').val(item.item.contact.firstname);
                        $('#lastname').val(item.item.contact.lastname);
                        $('#job').val(item.item.contact.job);
                        $('#email').val(item.item.contact.email);
                        $('#phone').val(item.item.contact.phone);
                        $('#mobile').val(item.item.contact.mobile);
                        $('#description').val(item.item.contact.description);
                    }
                    
                }

                if (fn == 'fillDealFromPreventive') {
                    if (!$('#equipment_name').val()) {
                        $('#deal_name').attr('disabled', false);
                    }
                }
            },
            focus: function (event, ui) {
                return false;
            },
            select: function (e, item) {
                if ($('#' + el.data("target-input-id")).length) {
                   $('#' + el.data("target-input-id")).val(item.item.id).change();
                }

                // Traitement supplémentaire
                const fn = el.data("extra-fn");

                if (fn == 'fillExpectedAtFromOrder') {
                    if (!$('#expected_at').val()) {
                        $('#expected_at').val(item.item.expected_at)
                    }
                }

                
                if (fn == 'fillDealFromMovement' || fn == 'fillDealFromPreventive') {
                    $('#deal_name').val(item.item.deal.designation);
                    $('#deal_id').val(item.item.deal.id);
                }

                if(fn == 'fillLotFromMovement'){
                    if($('#lot_label').length > 0){
                        $('#lot_label').data('filters', {'deal_id' : item.item.id, 'states' : "2,3"});
                    }
                }
                
              
                setTimeout(function () {
                    $(e.target).blur();
                })
            }
        }).focus(function () {
            el.autocomplete("search", '');
        });

        if (el.hasClass('article-autocomplete')) {
            el.autocomplete("instance")._renderItem = formatArticlesAutocomplete
        }

        if (el.hasClass('company-autocomplete')) {
            el.autocomplete("instance")._renderItem = formatCompaniesAutocomplete
        }
    });

    /**
     * Formattage de l'autocomplete des articles
     */
    function formatArticlesAutocomplete(ul, item) {
        let numberString = item.number ? "<br>Ref. interne: " + item.number : "";
        let referenceString = item.reference ? "<br>Ref. fournisseur: " + item.reference : "";
        return $("<li>")
            .append("<div>" + item.label + `<span style='font-size: 10px'>${numberString}${referenceString}</span></div>`)
            .appendTo(ul);
    }

    /**
     * Formattage de l'autocomplete des sociétés
     */
    function formatCompaniesAutocomplete(ul, item) {
        let labelSubcontractor = item.label_subcontractor ? "<br>" + item.label_subcontractor : "";
        let typeArea = item.type_area ? "<br>" + item.type_area : "";
        return $("<li>")
            .append("<div>" + item.label + `<span style='font-size: 10px'>${labelSubcontractor}${typeArea}</span></div>`)
            .appendTo(ul);
    }

    /**
     * Depuis un champs autocomplete (société, ..)
     * Mise en place des filtres sur des champs en autocomplete eux aussi (contact, adresse, ..)
     */
    $('.input-change-filters-autocomplete').change(function () {
        let f = $(this).attr('id')
        let targets = $(this).data('targets').split(',')
        let newValue = $(this).val()
        let clear = newValue == ''

        targets.forEach((target, index) => {
            if ($(`#${target}_id`).length && $(`#${target}_label`)) {
                // Verrouillage du champs
                if (clear) {
                    $(`#${target}_label`).prop('readonly', true)
                } else {
                    $(`#${target}_label`).prop('readonly', false)
                }

                if ($('#equipment_label')) {
                    $('#equipment_label').prop('readonly', false);
                }

                $(`#${target}_id`).val('')
                $(`#${target}_label`).val('')

                // Construction des filtres
                var filters = $(`#${target}_label`).data('filters')
                if (typeof filters != "object") {
                    filters = {}
                }

                // Affectation de la nouvelle valeur aux filtres du champs autocomplete target
                filters[f] = newValue
                $(`#${target}_label`).data('filters', filters)
            }
        })
    });
    /**
     * Récupération des informations d'une société pour précomplétion d'une page
     * Eg. Devis, Commande fournisseur avec adresse par défaut, etc ..
     */
    $('.input-trade-company-setup').change(function () {
        let newValue = $(this).val()
        if (newValue != '' && newValue != undefined) {
            var defaultsUrl = $(this).data('defaults-url').replace('##', newValue)
            $('#company_note').text('');
            $('#circle-load').css({ 'display': 'block' });
            fetch(defaultsUrl, {
                headers: getHeaders(),
                method: 'GET'
            }).then(function (response) {
                if (response.status == 200) {
                    response.json().then(function (data) {
                        if (data.data) {
                            let el = document.getElementById("discount");
                            if (data.data.billing_address) {
                                $('#address_id').val(data.data.billing_address.id)
                                $('#address_label').val(data.data.billing_address.line_formatted)
                            }

                            if (data.data.note) {
                                $('#circle-load').css({ 'display': 'none' });
                                $('#company_note').text(data.data.note);
                            } else {
                                $('#circle-load').css({ 'display': 'none' });
                                $('#company_note').text('Aucune note associée à cette entreprise');
                            }

                            if (data.data.payment_method_id) {
                                $('#payment_method_id').val(data.data.payment_method_id)
                            }

                            if (data.data.payment_delay_id) {
                                $('#payment_delay_id').val(data.data.payment_delay_id)
                            }

                            if(data.data.is_subcontractor != null && $('#is_subcontractor').length > 0){
                                $('#is_subcontractor').val(data.data.is_subcontractor)
                            }

                            if(data.data.type_area != null && $('#type_area').length > 0){
                                $('#type_area').val(data.data.type_area)
                            }

                            if(data.data.default_vat != null && $('#default_vat').length > 0){
                                $('#default_vat').val(data.data.default_vat)
                            }

                            if (data.data.discount && el != null) {
                                el.value = data.data.discount;
                                el.dispatchEvent(new Event('input'));

                                Swal.fire({
                                    title: 'Remise automatique',
                                    text: "Une remise de " + data.data.discount + "% a été appliquée depuis la fiche client.",
                                    icon: 'info',
                                    showCancelButton: false,
                                    confirmButtonText: 'Continuer',
                                    reverseButtons: true,
                                    heightAuto: false
                                })
                            }
                        }
                    })
                }
            }).catch(function (error) {
                alertError(null)
            });
        }
    })

    /**
     * Récupération des informations d'une commande pour précomplétion
     * Eg. BL
     */
    $('.input-trade-order-setup').change(function () {
        let newValue = $(this).val()
        if (newValue != '' && newValue != undefined) {
            var defaultsUrl = $(this).data('defaults-url').replace('##', newValue)

            fetch(defaultsUrl, {
                headers: getHeaders(),
                method: 'GET'
            }).then(function (response) {
                if (response.status == 200) {
                    response.json().then(function (data) {
                        if (data.data) {
                            var deliveryAddress = data.data.delivery_address ? data.data.delivery_address : data.data.billing_address;

                            if (deliveryAddress) {
                                $('#delivery_address_id').val(deliveryAddress.id)
                                $('#delivery_address_label').val(deliveryAddress.line_formatted)
                            }

                            if (data.data.company) {
                                $('#company_id').val(data.data.company.id)
                                $('#company_name').val(data.data.company.name)
                            }

                            $('#delivery_address_label').prop('readonly', false)
                        }
                    })
                }
            }).catch(function (error) {
                alertError(null)
            });
        } else {
            $('#company_id').val('')
            $('#company_name').val('')

            $('#delivery_address_id').val('')
            $('#delivery_address_label').val('')
            $('#delivery_address_label').prop('readonly', true)
        }
    })
    
    /**
     * Autocomplete depuis ligne
     * data-target-input-reference : Champs cible pour stockage de la référence
     * data-target-input-designation : Champs cible pour stockage de la designation
     * data-target-input-unit: Champs cible pour stockage de l'unité
     * data-target-input-amount : Champs cible pour stockage du montant
     * data-target-input-description : Champs cible pour stockage de la description
     */
    $('input.line-autocomplete').each(function (i, el) {
        el = $(el);
        el.autocomplete({
            minLength: 0,
            source: function (request, response) {
                $.ajax({
                    url: el.data("api-url"),
                    type: 'get',
                    dataType: 'json',
                    headers: getHeaders(),
                    data: { ...{ q: request.term }, ...el.data("filters") === undefined ? {} : el.data("filters") },
                    success: function (data) {
                        response($.map(data, function (item) {
                            return Object.assign(item, {
                                label: item.autocomplete_label,
                                value: item[el.data("value")] ?? ''
                            })
                        }))
                    }
                });
            },
            change: function (event, item) {
                // Si la valeur n'est pas selectionnée dans les suggestions (saisie libre)
                if (!item.item) {
                    $('#' + el.data("target-input-quantity-label")).html('-')
                    $('#' + el.data("target-input-line")).val('')
                }
            },
            focus: function (event, ui) {
                return false;
            },
            select: function (e, item) {
                if (item.item) {
                    $('#' + el.data("target-input-reference")).val(item.item.reference)
                    $('#' + el.data("target-input-designation")).val(item.item.designation)
                    $('#' + el.data("target-input-quantity")).val(item.item.remaining_quantity)
                    $('#' + el.data("target-input-unit")).val(item.item.unit)
                    $('#' + el.data("target-input-description")).val(item.item.description)
                    $('#' + el.data("target-input-line")).val(item.item.id)

                    $('#' + el.data('target-select-line-type')).val(item.item.is_title).change()
                    $('#' + el.data("target-input-quantity-label")).html(item.item.remaining_quantity)
                }

                setTimeout(function () {
                    $(e.target).blur();
                })
            }
        }).focus(function () {
            el.autocomplete("search", '');
        });
    });

    $('.check-all').click(function () {
        $('.' + $(this).data('check-all-container-target') + ' input[type="checkbox"]').prop('checked', this.checked)

        var container = $('.' + $(this).data('check-all-container-target')).closest('.check-all-container');
        displayActionsWhenSelectionNeeded(container)
        updateTextTotalRemaining();
        refreshInvoiceLineAmounts();
    })

    $('.check-one').change(function () {
        var checkAll = $('#' + $(this).data('check-all-target'));
        var checkAllContainer = $(this).closest('.check-all-container');
        var checkboxes = $("input[type=\"checkbox\"]:not(:checked)")
        let uncheckedCount = checkAllContainer.find(checkboxes).length

        displayActionsWhenSelectionNeeded(checkAllContainer)
        updateTextTotalRemaining();
        refreshInvoiceLineAmounts();

        if (uncheckedCount == 0) {
            checkAll.prop('checked', true)
        } else {
            checkAll.prop('checked', false)
        }
    })

    function displayActionsWhenSelectionNeeded(container) {
        var checkedCheckboxes = $("input[type=\"checkbox\"]:checked")
        let checkedCount = container.find(checkedCheckboxes).length

        if (checkedCount > 0) {
            $('.need-selection').css('display', 'block')
        } else {
            $('.need-selection').attr('style', 'display: none !important');
        }
    }

    $('#allow_login_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_allow: allow })
        }).then(function (response) {
            if (response.status != 200) {
                if (allow) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (allow) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

    // Édition d'un pointage utilisateur : afficher / masquer la liste des pointages
    // matériels associés et permettre une sélection fine de ceux à mettre à jour.
    if ($('#equipment-checkings-list').length) {
        const $list  = $('#equipment-checkings-list');
        const $cbs   = $('.equipment-checking-checkbox');

        function toggleEquipmentCheckingsList() {
            if ($('#edit_equipment_checking_true').is(':checked')) {
                $list.show();
            } else {
                $list.hide();
            }
        }

        $('input[name="edit_equipment_checking"]').on('change', toggleEquipmentCheckingsList);

        $('#equipment-checkings-select-all').on('click', function () {
            $cbs.prop('checked', true);
        });

        $('#equipment-checkings-unselect-all').on('click', function () {
            $cbs.prop('checked', false);
        });
    }

    $('#fast_checking_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ fast_checking: allow })
        }).then(function (response) {
            if (response.status != 200) {
                if (allow) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (allow) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

 

    $('#lost_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_lost: allow })
        }).then(function (response) {
            if (response.status != 200) {
                if (allow) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (allow) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

    $('#sleeping_switch').change(function () {
        const el = $(this)
        const allow = $(this).is(':checked')

        fetch($(this).data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_sleeping: allow })
        }).then(function (response) {
            if (response.status != 200) {
                el.prop('checked', !allow)
            }
        }).catch(function () {
            el.prop('checked', !allow)
        });
    })


    $('#switch_status').change(function () {
        const el = $(this)
        const check = el.is(':checked')

        fetch(el.data('api-url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ is_check: check })
        }).then(function (response) {
            if (response.status != 200) {
                if (check) {
                    el.prop('checked', false)
                } else {
                    el.prop('checked', true)
                }
            }
        }).catch(function (error) {
            if (check) {
                el.prop('checked', false)
            } else {
                el.prop('checked', true)
            }
        });
    })

     /**
     * Modal décision facture fournisseur (refus / litige)
     * Injecte le state et réinitialise le formulaire
     */
    $('#billDecisionModal').on('show.bs.modal', function (e) {
        var btn   = $(e.relatedTarget);
        var state = btn.data('state');
        $(this).find('#billDecisionState').val(state);
        $(this).find('#billDecisionReason').val('');
    });

    /**
     * Paiement multiple depuis sélection
     */
    $('.pay-all').click(function () {
        const checkboxes = $('.check-payable').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#paymentPayableId').val(ids.join())
            $('#createPaymentModal').modal()
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }
    });
    /** 
     * Affichage/Masquage du champ de saisie du moyen de paiement si l'avoir est déduit  
    */
    function togglePaymentMethod() {
        if ($('#deductible_yes').is(':checked')) {
            $('#payment_method_div').hide();
        } else {
            $('#payment_method_div').show();
        }
    }

    // Appel initial pour définir l'état correct au chargement
    togglePaymentMethod();

    // On détecte le changement de valeur de l'input radio
    $('input[type=radio][name="payment[is_deductible]"]').change(function() {
        togglePaymentMethod();
    });



    /**
     * Création ordre de paiement depuis liste des factures fournisseurs
     */
    $('.payment-orders-all').click(function () {
        const checkboxes = $('.check-payable').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#paymentOrderBillIds').val(ids.join())
            $('#createPaymentOrderModal').modal()
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }
    });
    

    $('.all-visa-expenses').click(function () {
        const checkboxes = $('.check-expenses').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];
        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#expenseVisaIds').val(ids.join())
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

    }) 


    $('.valid-all-checkings').click(function () {
        const checkboxes = $('.check-checkings').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];
        if (checkboxes.length > 0) {
            // met moi un swal pour confirmer l'action, si oui on valid le formulaire
            Swal.fire({
                title: 'Confirmation',
                text: "Êtes-vous sûr de vouloir valider ces pointages ?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
                reverseButtons: true,
                heightAuto: false
            }).then((result) => {
                if (result.isConfirmed) {
                    checkboxes.each(function () {
                        ids.push($(this).val())
                    })
                    $('#checkingValidIds').val(ids.join())
                    $('#validCheckingsForm').submit()
                }
            })
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

    }) 

    /**
     * Confirmation modal before enabling public (third-party) access on contact switch
     */
    $(document).on('change', '.auth_allowed_public_switch', function (e) {
        const el = $(this);
        const allow = el.is(':checked');
        const apiUrl = el.data('api-url');
        const contactName = el.data('contact-name') || '';
        const contactEmail = el.data('contact-email') || '';

        function showInlineAlert(type, text) {
            const alertClass = type === 'success' ? 'alert-success' : 'alert-danger';
            const icon = type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle';
            const $alert = $(
                '<div class="alert '+alertClass+' alert-dismissible fade show position-fixed" style="top:20px;right:20px;z-index:9999;min-width:320px;">'
                + '<i class="fas '+icon+' mr-2"></i>' + text
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
                + '</div>'
            );
            $('body').append($alert);
            setTimeout(() => { $alert.alert('close'); }, 5000);
        }

        function sendUpdate(allowed) {
            return fetch(apiUrl, {
                headers: getHeaders(),
                method: 'PUT',
                body: JSON.stringify({ auth_allowed: allowed })
            }).then(function (response) {
                if (response.status == 200) {
                    // Hide modal if present
                    if (allowed) {
                        const $m = $('#confirmPublicAccessModal');
                        if ($m.length) { $m.modal('hide'); }
                    }
                    setTimeout(function () { location.reload(); }, allowed ? 200 : 0);
                } else {
                    el.prop('checked', !allowed);
                    showInlineAlert('error', "Une erreur est survenue lors de la mise à jour de l'accès.");
                }
            }).catch(function () {
                el.prop('checked', !allow);
                // Hide modal on error if present
                const $m = $('#confirmPublicAccessModal');
                if ($m.length) { $m.modal('hide'); }
                showInlineAlert('error', "Impossible de contacter le serveur. Veuillez réessayer.");
            });
        }

        // If disabling, update immediately without modal
        if (!allow) {
            return sendUpdate(false);
        }

        // If enabling, show confirmation modal
        const $modal = $('#confirmPublicAccessModal');
        if ($modal.length === 0) {
            // Fallback: no modal available, revert and do nothing
            el.prop('checked', false);
            return;
        }

        $('#modalContactName').text(contactName);
        $('#modalContactEmail').text(contactEmail);

        const onConfirm = function () {
            $modal.off('hidden.bs.modal', onHide);
            $('#confirmPublicAccessBtn').off('click', onConfirm);
            // UI loading state
            const $btn = $('#confirmPublicAccessBtn');
            const originalHtml = $btn.html();
            $btn.data('original-html', originalHtml);
            $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Activation...');
            el.prop('disabled', true);

            sendUpdate(true).finally(function(){
                // Restore UI if not reloaded yet (in case of error)
                $btn.prop('disabled', false).html($btn.data('original-html'));
                el.prop('disabled', false);
            });
        };

        const onHide = function () {
            // If user closed modal without confirming, revert the switch
            el.prop('checked', false);
            $modal.off('hidden.bs.modal', onHide);
            $('#confirmPublicAccessBtn').off('click', onConfirm);
        };

        $('#confirmPublicAccessBtn').on('click', onConfirm);
        $modal.on('hidden.bs.modal', onHide);
        $modal.modal('show');
    });

    $('.all-fast-invoices-payments').click(function () {
        const checkboxes = $('.check-fast-invoices').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })
            $('#invoiceIds').val(ids.join());
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

        
    })

    $('.all-maintenance-operations').click(function () {
        const checkboxes = $('.check-maintenance-operations').find($("input[type=\"checkbox\"]:checked"));
        var ids = [];

        if (checkboxes.length > 0) {
            checkboxes.each(function () {
                ids.push($(this).val())
            })

            $('#maintenanceOperationsIds').val(ids.join())
        } else {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez sélectionner au moins 1 élément du tableau afin de pouvoir utiliser cette fonction",
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Compris',
                reverseButtons: true,
                heightAuto: false
            })
        }

    })

    /*
    * Ajout d'un compte depuis la modal du plan comptable
    */
    $('.button-add-accounting').on('click', function (e) {
        e.preventDefault();
        let accountingType = $(this).data('accounting-type');
        let companyName = $('#name').length ? $('#name').val() : '';

        if (accountingType == 'eco') {

            $('#modal_accounting_name').val('Produits issus d\'activités annexes');
            $('#modal_accounting_general').val('708');
            $('#modal_accounting_type').val('eco');
        } else {
            let isCompany = accountingType == 'company';
            $('#modal_accounting_name').val(isCompany ? 'Compte client ' + companyName : 'Compte fournisseur ' + companyName);
            $('#modal_accounting_general').val(isCompany ? '411' : '401');
            $('#modal_accounting_type').val(isCompany ? 'company' : 'provider');
        }

        $('#createAccountingAccountModal').modal();
    });
    
    $('#modal-submit-accounting').on('click', function (e) {
        e.preventDefault();

        let accountingGeneral = $('#modal_accounting_general').val();
        let accountingAuxiliary = $('#modal_accounting_auxiliary').val();
        let accountingName = $('#modal_accounting_name').val();

        if (accountingGeneral == '' || accountingName == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires");
        } else {
            let submitUrl = $(this).data('submit-url');
            var data = {
                general: accountingGeneral,
                auxiliary: accountingAuxiliary,
                name: accountingName
            };


            disableButtonAndLoad($(this));

            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(data)
            }).then(res => {
                if (res.status == 200 || res.status == 201) {
                    res.json().then((data) => {
                        if (data.data) {
                            let accountingType = $('#modal_accounting_type').val();
                            if (accountingType == 'company') {
                                $('#client_accounting_account_designation').val(data.data.designation);
                                $('#client_accounting_account_id').val(data.data.id);
                            } else if (accountingType == 'provider') {
                                $('#provider_accounting_account_designation').val(data.data.designation);
                                $('#provider_accounting_account_id').val(data.data.id);
                            } else if (accountingType == 'eco') {
                                $('#accounting_account_designation').val(data.data.designation);
                                $('#accounting_account_id').val(data.data.id);
                            }

                            $('#modal_accounting_general').val('');
                            $('#modal_accounting_auxiliary').val('');
                            $('#modal_accounting_name').val('');


                            $('#createAccountingAccountModal').modal('hide');
                        } else {
                            alertError(null);
                        }
                        resetButtonAfterLoad($(this));
                    })
                } else {
                    console.log(res.status);
                    alertError(res.status == 422 ? 'Le compte renseigné existe déjà' : null);
                    resetButtonAfterLoad($(this));
                }

            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });


    /** Edition d'un compte depuis la modale plan comptable */
    $('.button-edit-accounting').on('click', function (e) {
        let accountType = $(this).data('accounting-type');
        let accountId = $(this).data('account-id');
        let accountGeneral = $(this).data('account-general');
        let accountAuxiliary = $(this).data('account-auxiliary');
        let accountName = $(this).data('account-name');
        let dataUrl = $(this).data('url');
        
        // Update the modal fields
        $('#modal_edit_accounting_general').val(accountGeneral);
        $('#modal_edit_accounting_auxiliary').val(accountAuxiliary);
        $('#modal_edit_accounting_name').val(accountName);
        $('#modal_edit_accounting_id').val(accountId);
        $('#modal_edit_accounting_type').val(accountType);
        // Update 
        $('#modal-submit-edit-accounting').attr('data-submit-url', dataUrl);

        $('#editAccountingAccountModal').modal();

    });

    $('#modal-submit-edit-accounting').on('click', function (e) {

        e.preventDefault();

        let accountingGeneral = $('#modal_edit_accounting_general').val();
        let accountingAuxiliary = $('#modal_edit_accounting_auxiliary').val();
        let accountingName = $('#modal_edit_accounting_name').val();
        let accountingId = $('#modal_edit_accounting_id').val();
        let accountType= $('#modal_edit_accounting_type').val();

        if (accountingGeneral == '' || accountingName == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires");
        } else {
            let submitUrl = $(this).data('submit-url');
            var data = {
                type : accountType,
                general: accountingGeneral,
                auxiliary: accountingAuxiliary,
                name: accountingName,
                id : accountingId,
            };

            disableButtonAndLoad($(this));

            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'PUT',
                body: JSON.stringify(data)
            }).then(res => {
                if (res.status == 200 || res.status == 201) {
                    res.json().then((data) => {
                        resetButtonAfterLoad($(this));
                        // Close the modal
                        $('#editAccountingAccountModal').modal('hide');
                        // On recharge la page
                        location.reload();
                        
                    })
                } else {
                    console.log(res.status);
                    alertError(res.status == 422 ? 'Le compte renseigné existe déjà' : null);
                    resetButtonAfterLoad($(this));
                }

            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });

    /**
     * Ajout d'une société depuis modal 
     */
    $('.button-add-company').on('click', function(e){
        $('#addCompanyModal').modal();
        

        $('#modal_is_enterprise').change(function() {
            let value = this.value;
            // Gestion cas particulier 
            if(value == 0){
                $('#modal_contact_section').css({'display' : 'block'});
            } else {
                $('#modal_contact_section').css({'display' : 'none'});
            }


            e.preventDefault();
        });

        $('#button-submit-company').off('click').click(function () {
            let companyModalName = $('#autocomplete_company_name').val();
            let companyModalPhone = $('#modal_phone').val();
            let companyModalMail =  $('#modal_email').val();
            let companyModalFirstName = $('#modal_firstname').val();
            let companyModalIsEnterprise = $('#modal_is_enterprise').val();

            if(companyModalName == '')
                alertError("Veuillez renseigner l'ensemble des champs obligatoires");
            else {
                let submitUrl = $(this).data('submit-url')
                
                var data = {
                    name: companyModalName,
                    email: companyModalMail,
                    phone: companyModalPhone,
                    firstname: companyModalFirstName,
                    warranty_cap_inactive: true,
                    state: 2,
                    is_enterprise: companyModalIsEnterprise,
                    gender: 1,
                };

                disableButtonAndLoad($(this));

                 // Envoi serveur
                fetch(submitUrl, {
                    headers: getHeaders(),
                    method: 'POST',
                    body: JSON.stringify(data)
                }).then(res => {
                    res.json().then((data) => {
                        if (data.data) {
                            $('#company_id').val(data.data?.id);
                            $('#company_name').val(data.data?.name).trigger('change');
                            console.log($('#company_id').val());

                            // Réinitialisation du formulaire de la modal
                            $('#autocomplete_company_name').val('');
                            $('#modal_phone').val('');
                            $('#modal_email').val('');
                            $('#modal_firstname').val();
                            $('#modal_is_enterprise').val(1);

                            $('#addCompanyModal').modal('hide')
                        } else {
                            let errorMessage = null;
                            if (data && data.errors) {
                                errorMessage = Object.values(data.errors).map(err => Array.isArray(err) ? err.join(', ') : err).join('\n');
                            } else if (data && data.message) {
                                errorMessage = data.message;
                            }
                            alertError(errorMessage);
                        }

                        resetButtonAfterLoad($(this));
                    })
                }).catch((error) => {
                    alertError(null)
                    resetButtonAfterLoad($(this));
                });
                }
            })
    });

    /**
     * Ajout adresse depuis modal (devis, commandes, factures, etc .. par exemple)
     */
    $('.button-add-address').click(function () {
        let companyName = $('#company_name').val()
        let companyId = $('#company_id').val()
        let isBilling = $(this).data('address-type') == 'billing'

        // Vérification de la présence d'un nom de société
        if (companyName == '' || companyName == undefined || companyName == null) {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez d'abord renseigner le nom de la société avant de pouvoir saisir une nouvelle adresse",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                reverseButtons: true
            })
        } else {
            $('#modal_address_type').val($(this).data('address-type'))
            $('#modal_address_company_name').val(companyName)
            $('#modal_address_company_id').val(companyId)

            if (isBilling) {
                $("#modal_address_is_default_true").prop("checked", true);;
            } else {
                $("#modal_address_is_default_false").prop("checked", true);;
            }

            $('#addAddressModal').modal()
        }
    });

    $('#button-submit-address').click(function () {
        let companyName = $('#modal_address_company_name').val()
        let companyId = $('#modal_address_company_id').val()
        let name = $('#modal_address_name').val()
        let address1 = $('#modal_address_address_1').val()
        let address2 = $('#modal_address_address_2').val()
        let zipCode = $('#modal_address_zip_code').val()
        let city = $('#modal_address_city').val()
        let country = $('#modal_address_country').val()
        let description = $('#modal_address_description').val()
        let is_default = $("input[name=modal_address_is_default]:checked").val()

        // Contrôle du formulaire
        if (companyName == '' || name == '' || address1 == '' || zipCode == '' || city == '' || country == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires")
        } else {
            let submitUrl = $(this).data('submit-url')
            var data = {
                is_default: is_default,
                company_name: companyName,
                name: name,
                address_1: address1,
                address_2: address2,
                zip_code: zipCode,
                city: city,
                country: country,
                description: description,
            };

            if (companyId != '' && companyId != undefined && companyId != null) {
                data.company_id = companyId
            }

            disableButtonAndLoad($(this));

            // Envoi serveur
            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(data)
            }).then(res => {
                res.json().then((data) => {
                    if (data.data) {
                        // affectation au formulaire principal
                        $('#company_name').val(companyName)

                        let currentCompanyId = $('#company_id').val();
                        if (currentCompanyId != data.data.company_id) {
                            $('#company_id').val(data.data.company_id).trigger('change')
                        }

                        let addressType = $('#modal_address_type').val()
                        if (addressType == 'delivery') {
                            $('#delivery_address_label').val(data.data.line_formatted)
                            $('#delivery_address_id').val(data.data.id)
                        } else {
                            $('#address_label').val(data.data.line_formatted).trigger('input')
                            $('#address_id').val(data.data.id).trigger('input').trigger('change')
                        }

                        // Réinitialisation du formulaire de la modal
                        $('#modal_address_company_name').val('')
                        $('#modal_address_company_id').val('')
                        $('#modal_address_name').val('')
                        $('#modal_address_address_1').val('')
                        $('#modal_address_address_2').val('')
                        $('#modal_address_zip_code').val('')
                        $('#modal_address_city').val('')
                        $('#modal_address_country').val('')
                        $('#modal_address_description').val('')
                        $('#modal_address_type').val('')

                        // Fermeture modal
                        $('#addAddressModal').modal('hide')
                    } else {
                        alertError(null)
                    }

                    resetButtonAfterLoad($(this));
                })
            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });

    $('#button-add-contact').click(function () {
        let companyName = $('#company_name').val()
        let companyId = $('#company_id').val()

        // Vérification de la présence d'un nom de société
        if (companyName == '' || companyName == undefined || companyName == null) {
            Swal.fire({
                title: 'Attention',
                text: "Vous devez d'abord renseigner le nom de la société avant de pouvoir saisir un nouveau contact",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                reverseButtons: true
            })
        } else {
            $('#modal_contact_company_name').val(companyName)
            $('#modal_contact_company_id').val(companyId)
            $('#addContactModal').modal()
        }
    });

    $('#button-submit-contact').click(function () {
        let companyName = $('#modal_contact_company_name').val()
        let companyId = $('#modal_contact_company_id').val()
        let gender = $('input[name=modal_contact_gender]:checked').val()
        let lastname = $('#modal_contact_lastname').val()
        let firstname = $('#modal_contact_firstname').val()
        let job = $('#modal_contact_job').val()
        let email = $('#modal_contact_email').val()
        let phone = $('#modal_contact_phone').val()
        let mobile = $('#modal_contact_mobile').val()
        let description = $('#modal_contact_description').val()

        // Contrôle du formulaire
        if (lastname == '') {
            alertError("Veuillez renseigner l'ensemble des champs obligatoires")
        } else {
            let submitUrl = $(this).data('submit-url')
            var data = {
                company_name: companyName,
                gender: gender,
                lastname: lastname,
                firstname: firstname,
                job: job,
                email: email,
                phone: phone,
                mobile: mobile,
                description: description,
            };

            if (companyId != '' && companyId != undefined && companyId != null) {
                data.company_id = companyId
            }

            disableButtonAndLoad($(this));

            // Envoi serveur
            fetch(submitUrl, {
                headers: getHeaders(),
                method: 'POST',
                body: JSON.stringify(data)
            }).then(res => {
                res.json().then((data) => {
                    if (data.data) {
                        // affectation au formulaire principal
                        $('#company_name').val(companyName)

                        let currentCompanyId = $('#company_id').val();
                        if (currentCompanyId != data.data.company_id) {
                            $('#company_id').val(data.data.company_id).trigger('change')
                        }

                        $('#contact_label').val(data.data.fullname)
                        $('#contact_id').val(data.data.id)

                        // Réinitialisation du formulaire de la modal
                        $('#modal_contact_company_name').val('')
                        $('#modal_contact_company_id').val('')
                        $("#modal_contact_gender1").prop("checked", true);
                        $('#modal_contact_lastname').val('')
                        $('#modal_contact_firstname').val('')
                        $('#modal_contact_job').val('')
                        $('#modal_contact_email').val('')
                        $('#modal_contact_phone').val('')
                        $('#modal_contact_mobile').val('')
                        $('#modal_contact_description').val('')

                        // Fermeture modal
                        $('#addContactModal').modal('hide')
                    } else {
                        alertError(null)
                    }

                    resetButtonAfterLoad($(this));
                })
            }).catch((error) => {
                alertError(null)
                resetButtonAfterLoad($(this));
            });
        }
    });

    /**
     * Depuis un bouton dans une ligne d'un tableau, permet la suppression de la ligne en question
     */
    $(document).on('click', '.delete-current-row', function (e) {
        e.preventDefault();
        $(this).closest("tr").remove();
    });

    /**
     * Module Tags
     * Transforme un input/textarea en selecteur de tags
     *
     * https://github.com/yairEO/tagify
     */
    document.querySelectorAll('.tag-autocomplete').forEach(createInputTag);

    function createInputTag(field) {
        var timeout;
        var controller;
        var whiteList = field.getAttribute('data-white-list');
        var allowTagCreate = field.getAttribute('data-allow-create') == "false" ? false : true;

        if (whiteList == '' || whiteList == undefined || whiteList == null) {
            whiteList = [];
        } else {
            whiteList = JSON.parse(inputTag.getAttribute('data-white-list'));
        }

        var tagify = new Tagify(field, {
            autocomplete: true,
            whitelist: whiteList,
            addTagOnBlur: false,
            editTags: false,
            originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(',')
        });

        tagify.on('focus', e => {
            updateInputTagSuggestion('')
        })
        tagify.on('input', e => {
            var value = e.detail.value;
            updateInputTagSuggestion(value)
        })
        tagify.on('add', e => {
            if (allowTagCreate == false && tagify.settings.whitelist.length == 0) {
                tagify.removeTag(e.detail.tag)
            }
        })

        function updateInputTagSuggestion(value) {
            if (value != '') {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    fetchTagsRemote(value)
                }, 500);
            } else {
                fetchTagsRemote(value)
            }
        }

        function fetchTagsRemote(value) {
            tagify.settings.whitelist.length = 0;

            controller && controller.abort();
            controller = new AbortController();

            tagify.loading(true).dropdown.hide.call(tagify)

            fetch('/api/tags/autocomplete?q=' + value + '&type=' + field.getAttribute('data-type'), {
                signal: controller.signal,
                headers: getHeaders()
            }).then(res => res.json())
                .then(function (whitelist) {
                    // update inwhitelist Array in-place
                    tagify.settings.whitelist.splice(0, whitelist.length, ...whitelist)
                    tagify.loading(false).dropdown.show.call(tagify, value);
                })
                .catch(function (error) {
                    tagify.loading(false)
                });
        }
    }

    /**
     * Lecture automatique de code barre
     *
     * https://github.com/zxing-js/library
     */
    $(document).on('click', '.barcode-trigger', function () {
        $('#input-target').val('#' + $(this).data("target-input-id"));
        $('#barcode-reader-modal').modal({});

        const hints = new Map();
        const formats = [BarcodeFormat.CODE_128, BarcodeFormat.CODE_39, BarcodeFormat.CODE_93, BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.UPC_A, BarcodeFormat.UPC_E, BarcodeFormat.UPC_EAN_EXTENSION];
        hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);

        const codeReader = new BrowserMultiFormatReader(hints);

        navigator.mediaDevices.getUserMedia({ video: true }).then(() => {
            // Récupération des différentes sources
            codeReader.listVideoInputDevices().then((videoInputDevices) => {
                const sourceSelect = document.getElementById('sourceSelect')
                var selectedDeviceId;

                if (videoInputDevices.length > 0) {
                    selectedDeviceId = videoInputDevices[0].deviceId
                    startReader()
                }

                if (videoInputDevices.length >= 1) {
                    if (sourceSelect.length == 0) {
                        videoInputDevices.forEach((element) => {
                            const sourceOption = document.createElement('option');
                            sourceOption.text = element.label;
                            sourceOption.value = element.deviceId;
                            sourceSelect.appendChild(sourceOption)
                        })
                    }

                    const sourceSelectPanel = document.getElementById('sourceSelectPanel');
                    sourceSelectPanel.style.display = 'block';

                    sourceSelect.onchange = () => {
                        selectedDeviceId = sourceSelect.value;
                        codeReader.reset();
                        startReader();
                    };
                }

                function startReader() {
                    codeReader.decodeFromVideoDevice(selectedDeviceId, 'video', (result, err) => {
                        if (result) {
                            let id = $('#input-target').val();
                            let target = $(id);
                            if (target.length) {
                                target.val(result.text);
                                target[0].dispatchEvent(new Event('input'));

                                if (id == '#badge') {
                                    $('#secret').focus();
                                } else if (id == '#lot') {
                                    document.dispatchEvent(new CustomEvent('lotSearchUpdated', { detail: result.text }));
                                } else if (id == '#intervention') {
                                    document.dispatchEvent(new CustomEvent('interventionSearchUpdated', { detail: result.text }));
                                } else if (id == '#search') {
                                    document.dispatchEvent(new CustomEvent('scanSearchUpdated', { detail: result.text }));
                                }

                                if (target.data('is-autocomplete') == true) {
                                    target.data("ui-autocomplete")._search(result.text)
                                }
                            }

                            $('#barcode-reader-modal').modal('hide')
                        }
                        if (err && !(err instanceof NotFoundException)) {
                            console.log(err)
                        }
                    })
                }
            }).catch((err) => {
                console.error(err)
            })

            $('#barcode-reader-modal').on('hidden.bs.modal', function (e) {
                codeReader.reset()
                $('#input-target').val('')
            })
        })
    })

    /**
     * Sortable
     */
    var sortableContainers = document.getElementsByClassName('sortable-container');
    Array.prototype.forEach.call(sortableContainers, function (sortableContainer) {
        Sortable.create(sortableContainer, {
            ghostClass: 'ix-sortable-ghost-background',
            handle: '.handle',
            animation: 150,
            onEnd: function (e) {
                var dropEl = e.item;

                fetch(dropEl.dataset.moveUrl, {
                    headers: getHeaders(),
                    method: 'PUT',
                    body: JSON.stringify({ new_index: e.newIndex })
                }).then(res => res.json())
                    .catch(function (error) {
                        console.log(error)
                    });
            }
        });
    });

    /**
     * Bouton clipboard
     */
    $('.copy-button').click(function (e) {
        e.preventDefault()
        var target = $(this).data("target")
        var copyText = document.getElementById(target);
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
    })

    var previousInvoiceType = null;
    // Modale « Nouvelle facture » : réglages et zones affichés selon le type (facture, acompte, récurrente)
    function updateInvoiceFormState() {
        const selectInvoiceType = $('.select-invoice-type');
        if (!selectInvoiceType.length) return;

        const type = selectInvoiceType.val();
        const typeChanged = previousInvoiceType !== null && previousInvoiceType !== type;
        previousInvoiceType = type;
        const form = selectInvoiceType.closest('form');
        const switchType = $('#change_type_invoiced');

        // Changement de type : on repart des réglages par défaut
        if (typeChanged) {
            $('#percent').val('');
            $('#global_percentage').val('');
            $('#deduct_acompte').prop('checked', false);
            switchType.prop('checked', false);
            $('#acompte_mode_switch').prop('checked', false);
            $('#acompte_mode_hidden').val('percent');
            $('#acompte_amount').val('');
        }

        const isInvoice = type == '0';
        const isAcompte = type == '1';
        const isRecurrence = type == '2';
        const isProgress = isInvoice && switchType.is(':checked');
        const isPercentMode = isProgress && $('input[name="invoice_mode"]:checked').val() != 'quantity';
        const isAmountMode = $('#acompte_mode_switch').is(':checked');

        form.attr('action', selectInvoiceType.data(isRecurrence ? 'recurrence-url-form' : 'invoice-url-form'));
        // Un seul champ « percent » envoyé : celui de l'acompte, ou 100 % pour une récurrence
        $('#percent, #acompte_amount').prop('disabled', !isAcompte);
        $('#recurrence_percent').prop('disabled', !isRecurrence);
        $('#name, #periodicity, #first_at').prop('required', isRecurrence);

        // Réglages
        $('#input_change_type_invoiced').toggle(isInvoice);
        $('#invoice-mode-block').toggle(isProgress);
        $('#global-percentage-block').toggle(isPercentMode);
        $('#percent-bloc').toggle(isAcompte);
        $('#acompte-percent-input-block').toggle(isAcompte && !isAmountMode);
        $('#acompte-amount-input-block').toggle(isAcompte && isAmountMode);

        // Contenu
        $('#acompte-deduction-block').toggle(isInvoice);
        $('#draft-acompte-notice').toggle(isInvoice);
        $('#recurrences-informations').toggle(isRecurrence);
        $('#acompte-preview').toggle(isAcompte);
        $('#invoice-lines-body').toggle(!isAcompte);
        form.find('.quantity-field').toggle(!isPercentMode);
        form.find('.percentage-field').toggle(isPercentMode);
        $('#invoice-lines-body .ix-inv-table').toggleClass('is-recurrence', isRecurrence);
        $('#invoice-current-group').text(isRecurrence ? 'Par échéance' : 'Cette facture');

        $('#invoice-submit-btn')
            .text(isAcompte ? 'Générer la facture' : (isRecurrence ? 'Créer la récurrence' : 'Créer la facture'))
            .prop('disabled', false).removeClass('disabled');

        syncInvoiceSegments();
        refreshInvoiceLineAmounts();
    }

    // Boutons segmentés : mettent à jour le champ réel, qui déclenche le comportement existant
    $(document).on('click', '#createInvoiceModal .ix-segmented button', function () {
        const group = $(this).closest('.ix-segmented');
        const input = $(group.data('input'));
        const value = String($(this).data('value'));

        if (input.is('select')) {
            if (input.val() !== value) input.val(value).trigger('change');
        } else if (input.is(':radio')) {
            const target = input.filter('[value="' + value + '"]');
            if (!target.is(':checked')) target.prop('checked', true).trigger('change');
        } else {
            const checked = value === String(group.data('checked-value'));
            if (input.is(':checked') !== checked) input.prop('checked', checked).trigger('change');
        }
        syncInvoiceSegments();
    });

    // Composition d'un lot : repliée par défaut, dépliée par la flèche de la ligne principale
    $(document).on('click', '#createInvoiceModal .ix-inv-toggle', function () {
        const open = !$(this).hasClass('is-open');
        $(this).toggleClass('is-open', open);
        $('#createInvoiceModal .form-lines-container tr.is-composition[data-parent="' + $(this).data('lot-id') + '"]').toggle(open);
    });

    // Récurrence : le rappel du rythme suit les champs
    $(document).on('input change', '#periodicity, #periodicity_unit, #first_at, #cycle', function () {
        if ($('.select-invoice-type').val() == '2') refreshInvoiceLineAmounts();
    });

    /**
     * Affichage ou non des champs pour la création facture récurrente
     */
    $('.select-invoice-type').change(function () {
        updateInvoiceFormState();
    });

    $('#change_type_invoiced').change(function (e){
        updateInvoiceFormState();
    });

    $(document).on('submit', '#createInvoiceModal form', function (e) {
        if ($('#invoice-submit-btn').prop('disabled')) {
            e.preventDefault();
            $(this).find('.form-lines-container tr.has-error').first().get(0)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
    });

    $(document).on('click', '#createInvoiceModal .ix-inv-fix-acompte', function () {
        const input = $('#acompte_mode_hidden').val() === 'amount' ? $('#acompte_amount') : $('#percent');
        input.val($(this).data('value')).trigger('input');
    });

    // Changement de mode : on repart des valeurs proposées (reste à facturer), sans reprendre la saisie de l'autre mode
    $(document).on('change', 'input[name="invoice_mode"]', function () {
        $('#global_percentage').val('');
        $('#createInvoiceModal .form-lines-container .quantity-input').each(function () {
            if ($(this).is('[readonly]')) return;
            const line = $('.check-all-container-lines input.check-one[value="' + $(this).data('line-id') + '"]');
            if (line.length) {
                $(this).val(line.data('suggested-invoice-quantity')).trigger('input');
            }
        });
        updateInvoiceFormState();
    });

    // Pourcentage global : appliqué à chaque ligne, dans la limite de son restant à facturer
    function applyGlobalPercentage(globalInput) {
        const global = parseFloat(globalInput.val());
        // Vide : les % restent saisis ligne par ligne
        if (isNaN(global)) {
            refreshInvoiceLineAmounts();
            return;
        }
        globalInput.closest('form').find('.percentage-input:not([readonly])').each(function () {
            const orderQuantity = parseFloat($(this).data('original-quantity')) || 0;
            const invoicedQuantity = parseFloat($(this).data('invoiced-quantity')) || 0;
            let remainingPercent = orderQuantity != 0 ? Math.max(0, Math.round((orderQuantity - invoicedQuantity) / orderQuantity * 10000) / 100) : 0;
            if (Math.abs(parseFloat((orderQuantity * remainingPercent / 100).toFixed(3))) > Math.abs(orderQuantity - invoicedQuantity) + 0.0005) {
                remainingPercent = Math.max(0, Math.floor((orderQuantity - invoicedQuantity) / orderQuantity * 10000) / 100);
            }
            $(this).val(Math.min(global, remainingPercent)).trigger('input');
        });
        refreshInvoiceLineAmounts();
    }

    $(document).on('click', '#apply-global-percentage', function () {
        applyGlobalPercentage($('#global_percentage'));
    });

    $(document).on('keydown', '#global_percentage', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            applyGlobalPercentage($(this));
        }
    });

   

    $(document).on('input', '#percent', function () {
        updateAcomptePreview();
    });

    // Acompte : saisie en % ou en montant TTC
    $(document).on('change', '#acompte_mode_switch', function() {
        $('#acompte_mode_hidden').val($(this).is(':checked') ? 'amount' : 'percent');
        updateInvoiceFormState();
    });

    $(document).on('input', '#acompte_amount', function() {
        updateAcomptePreview();
    });

    $('#active_guarantee').change(function (e){
        $('#guarantee-block').css('display', $(this).is(':checked') ? 'flex' : 'none');
    })

    $('#deduct_acompte').change(function (e){
        let deductionInfo = $('#acompte-deduction-info');
        if($(this).is(':checked')){
            deductionInfo.show();
        } else {
            deductionInfo.hide();
        }
        refreshInvoiceLineAmounts();
    })

    /**
     * Ouverture modal création de ligne de bl avec index
     */
    $('.add-delivery-line-index').click(function (e) {
        e.preventDefault()
        $('#position').val($(this).data('position'))
        $('#delivery_line').val($(this).data('delivery-line'))
        $('#addDeliveryLineModal').modal('show')
    })

    /**
     * Désactivation de l'envoi des formulaires à la soumission
     * Pour éviter le double envoi
     */
    $('form:not(.ajax-form)').submit(function (event) {
        if ($(this).hasClass('submitted')) {
            event.preventDefault();
        }
        else {
            event.preventDefault();

            if (!$(this).hasClass('refuse-quote-form') && !$(this).hasClass('delete-form') && !$(this).hasClass('duplicate-form') && !$(this).hasClass('confirm-form') && !$(this).hasClass('confirm-payment')) {
                disableSubmitButton(this)
                this.submit()
            }
        }
    });

    /**
     * Envoi requête serveur lors changement état switch
     */
    $('.toggle-remote').on('change', function (e) {
        let isChecked = $(this).prop('checked')
        let value = isChecked ? $(this).data('checked-value') : $(this).data('unchecked-value')

        if (!isChecked && $(this).data('delete-row')) {
            $(this).closest("tr").remove();
        }

        fetch($(this).data('url'), {
            headers: getHeaders(),
            method: 'PUT',
            body: JSON.stringify({ value: value })
        }).then(res => res.json())
            .catch(function (error) {
                console.log(error)
            });
    });

    /**
     * Ouverture modal renouvellement habilitation
     */
    $('.renew-ability').click(function (e) {
        e.preventDefault()
        let formUrl = $(this).data('form-url');
        let passAt = $(this).data('pass-at');

        $('#renewAbilityForm').attr('action', formUrl)
        $('#form_url').val(formUrl)
        $('#old_pass_at').val(passAt)

        $('#new_pass_at').data('date-start-date', passAt)
        $('#new_pass_at').datepicker('setStartDate', passAt);

        $('#renewAbilityModal').modal('show')
    })

    $('.history-ability').click(function (e) {
        e.preventDefault()
        let el = $(this)
        el.html('<i class="far fa-circle-notch fa-spin"></i>')
        el.prop("disabled", true)


        fetch(el.data('url'), {
            headers: getHeaders(),
            method: 'GET'
        }).then(function (response) {
            el.html('<i class="far fa-history"></i> Historique de passage')
            el.prop("disabled", false)

            if (response.status == 200) {
                response.json().then(function (data) {
                    let table = document.getElementById('ability-dates-list');
                    table.innerHTML = ""

                    data.forEach(date => {
                        table
                            .insertRow(-1)
                            .innerHTML = "<td>" + date + "</td>";
                    })

                    $('#historyAbilityModal').modal('show')
                })
            } else {
                alertError(null)
            }
        }).catch(function (error) {
            alertError(null)
            el.html('<i class="far fa-history"></i> Historique de passage')
            el.prop("disabled", false)
        });
    })

    $('.quantity-toggler').click(function (e) {
        const targetInput = $('#' + $(this).data('target-input'))
        var value = targetInput.val()
        if ($(this).data('operation') == 'add') {
            value++;
        } else {
            value--
        }

        targetInput.val(value)
    });

    /**
     * Modal de signature
     */
    $('.add-signature').click(function (e) {
        $('#input_target').val($(this).data('input-target'))
        $('#img_target').val($(this).data('img-target'))
        $('#original_sign').val($('#' + $(this).data('input-target')).val())
    })

    let signaturePad;
    $('#signModal').on('shown.bs.modal', function (e) {
        let canvas = $("#signature-pad canvas");
        let parentWidth = $(canvas).parent().outerWidth();
        canvas.attr("width", parentWidth + 'px');
        signaturePad = new SignaturePad(canvas[0]);

        if ($('#original_sign').val()) {
            signaturePad.fromDataURL($('#original_sign').val())
        }
    })

    $('#signModal').on('hidden.bs.modal', function (e) {
        signaturePad.clear();
    });

    $(document).on('click', '#signModal .clear-sign', function () {
        signaturePad.clear();
    });

    $(document).on('click', '#signModal .save-sign', function () {
        if (signaturePad.isEmpty()) {
            $('#' + $('#input_target').val()).val('')
            $('#' + $('#img_target').val()).attr('src', '');
        } else {
            let dataURL = signaturePad.toDataURL();
            $('#' + $('#input_target').val()).val(dataURL)
            $('#' + $('#img_target').val()).attr('src', dataURL);
        }

        $('#signModal').modal('hide');
    });

    $('#toggle-list-filters').on('click', function (e) {
        $(this).blur()
        if ($('#list-filters').is(":visible")) {
            $('#list-filters').hide();
        } else {
            $('#list-filters').show();
        }
    });

    // Donnée sensible masquée : l'œil alterne masque et valeur en clair, chargée (et journalisée) au premier clic
    $(document).on('click', '.ix-sensitive-toggle', function () {
        const button = $(this);
        const value = button.siblings('.ix-sensitive-value');
        const show = (text) => {
            value.text(text);
            button.attr({ title: 'Masquer', 'aria-label': 'Masquer' }).find('i').removeClass('fa-eye').addClass('fa-eye-slash');
        };

        if (button.find('i').hasClass('fa-eye-slash')) {
            value.text(button.data('mask'));
            button.attr({ title: 'Afficher', 'aria-label': 'Afficher' }).find('i').removeClass('fa-eye-slash').addClass('fa-eye');
            return;
        }

        if (button.data('value') !== undefined) {
            show(button.data('value'));
            return;
        }

        fetch(button.data('url'), { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
            .then(response => response.ok ? response.json() : Promise.reject(response))
            .then(data => {
                button.data('value', data.value);
                show(data.value);
            });
    });

    $('.trigger-sidebar').on('click', function (e) {
        $('#' + $(this).data('target')).toggleClass('open')
    });

    $('.trigger-close-sidebar').on('click', function (e) {
        $(this).closest('.ix-sidebar').removeClass('open')
    });

    $('.ix-table-btn-order').on('click', function (e) {
        e.preventDefault();
        const orderInputField = $('#orderBy');
        orderInputField.val($(this).data('order-value'));

        const form = orderInputField.closest('form');
        form.submit();
    });

    $('#create-invoice-modal').on('click', function (e) {
        e.preventDefault()
        openProcessLineModal('createInvoiceModal', 'invoice')
    });

    $('#create-delivery-modal').on('click', function (e) {
        e.preventDefault()
        openProcessLineModal('createDeliveryModal', 'delivery')
    });

    $('#lot-ventilation-modal').on('click', function(e) {
        e.preventDefault();
        openProcessLotModal('lotVentilationModal');
    })

    // Gestion des tags sur le tableau des achats de frais généraux
    $('.ix-tag-purchase').on('click', function (e) {
        var form = $(e.target).parent().parent().find('form')
        form.parent().find('.ix-tag-purchase').hide();
        form.css({ 'display': 'block' });

        form.find('button').on('click', function (event) {
            form.submit();
        })
    });


    var inputInjectPrediction = $('input[type=radio][name=inject_prediction]');
    inputInjectPrediction.on('change', function (e) {
        if (this.value == '1')
            $('.inject-prediction-remaining').css('display', 'block')
        else
            $('.inject-prediction-remaining').css('display', 'none')
    })

    function openProcessLotModal(modal){
        $('#' + modal).modal('show');


        // Suppression des précédents inputs de la modale de création de la facture
        const formLinesContainer = $('#' + modal).find($('.form-lines-container'))
        formLinesContainer.html('')

        // Récupération du nombre de lignes sélectionnées
        const checkboxes = $('.check-all-container-dealPurchases').find($("input[type=\"checkbox\"]:checked"));

        if (checkboxes.length > 0) {
            $('#' + modal).find($('table')).show()
            $('#' + modal).find($('.alert')).hide()
            $('#' + modal).find($('.save')).attr('disabled', false)
            

            checkboxes.each(function () {
                var id = $(this).val();
                var reference = $(this).data('reference');
                var purchaseId = $(this).data('purchase-id');
                var expense = $(this).data('expense');
                var expenseId = $(this).data('expense-id');
                var designation = $(this).data('designation');
                var suggestedPurchaseQuantity = $(this).data('suggested-purchase-quantity'); 
                var originalQuantity = $(this).data('quantity');
                var totalAfterDiscount = $(this).data('total_after_discount');
                var totalTtc = $(this).data('total_ttc');

                var row = `<tr>
                            <td>
                                <input type="hidden" name="dealPurchases[${id}][id]" value="${id}">
                                <input type="hidden" name="dealPurchases[${id}][purchase_id]" value="${purchaseId}">
                                <input type="hidden" name="dealPurchases[${id}][expense_id]" value="${expenseId}">
                                <input type="hidden" name="dealPurchases[${id}][reference]" value="${reference}">
                                <input type="hidden" name="dealPurchases[${id}][designation]" value="${designation}">
                                <input type="hidden" name="dealPurchases[${id}][original_quantity]" value="${originalQuantity}">
                                <input type="hidden" name="dealPurchases[${id}][total_ttc]" value="${totalTtc}">
                                <input type="hidden" name="dealPurchases[${id}][total_after_discount]" value="${totalAfterDiscount}">
                                ${expense}
                            </td>`
                row += `<td>${reference}</td><td>${designation}</td>
                        <td>
                            <input type="number" class="form-control form-control-sm text-center" max="${originalQuantity}" value="${suggestedPurchaseQuantity}" name="dealPurchases[${id}][quantity]" required step="0.001">
                        </td>`

                formLinesContainer.append(row)
            })
        } else {
            $('#' + modal).find($('table')).hide()
            $('#' + modal).find($('.alert')).show()
            $('#' + modal).find($('.save')).attr('disabled', true)
        }


    }

    // Éco-participations : cochées avec leur article, jamais seules (ni sans article valide)
    function syncEcoParticipationSelection() {
        const container = $('.check-all-container-lines');
        container.find('input.check-one').each(function () {
            if (parseInt($(this).data('is-eco')) !== 1) return;
            const parentId = $(this).data('eco-parent-line-id');
            const parent = parentId ? container.find('input.check-one[value="' + parentId + '"]') : $();
            $(this).prop('checked', parent.length > 0 && parent.is(':checked'));
        });
    }

    // Quantité d'une éco-participation : celle de son article × ratio des quantités commandées
    function syncEcoFollowQuantities(formLinesContainer) {
        formLinesContainer.find('[data-eco-parent-line-id]').each(function () {
            const parentId = $(this).data('eco-parent-line-id');
            const ratio = parseFloat($(this).data('eco-ratio')) || 0;
            const parentInput = formLinesContainer.find('input[name="lines[' + parentId + '][quantity]"]');
            // Article du détail d'un lot sans champ quantité : le serveur livre le reste à livrer
            const parentQuantity = parentInput.length
                ? parseFloat(parentInput.val()) || 0
                : parseFloat($('.check-all-container-lines').find('input.check-one[value="' + parentId + '"]').data('suggested-delivery-quantity')) || 0;
            const quantity = parseFloat((parentQuantity * ratio).toFixed(3));
            if ($(this).is('input')) {
                $(this).val(quantity);
            } else {
                $(this).text(quantity);
            }
        });
    }

    function syncLotDetailQuantities(formLinesContainer) {
        formLinesContainer.find('.lot-detail-quantity').each(function () {
            const mainInput = formLinesContainer.find('input[name="lines[' + $(this).data('lot-main-line-id') + '][quantity]"]');
            if (!mainInput.length) return;
            const ratio = parseFloat($(this).data('lot-ratio')) || 0;
            $(this).val(parseFloat(((parseFloat(mainInput.val()) || 0) * ratio).toFixed(3)));
        });
    }

    function openProcessLineModal(modal, type) {
        // Suppression des précédents inputs de la modale de création de la facture
        const formLinesContainer = $('#' + modal).find($('.form-lines-container'))
        formLinesContainer.html('')

        syncEcoParticipationSelection();

        // Récupération du nombre de lignes sélectionnées
        const checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));

        if (checkboxes.length > 0) {
            $('#' + modal).find($('table')).show()
            $('#' + modal).find($('.alert')).hide()

            // Facture : chaque ligne du détail d'un lot (titres, composition, éco) est repliée sous sa ligne principale
            const lotParents = {};
            const lotChildren = {};
            let currentLot = null;
            checkboxes.each(function () {
                const id = $(this).val();
                if ($(this).data('lot-main') == 1) {
                    currentLot = id;
                } else if ($(this).data('lot-line') == 1 && currentLot) {
                    lotChildren[id] = currentLot;
                    lotParents[currentLot] = true;
                } else {
                    currentLot = null;
                }
                if ($(this).data('lot-main-line-id')) lotParents[$(this).data('lot-main-line-id')] = true;
            });

            checkboxes.each(function () {
                if (type == 'invoice') {
                    formLinesContainer.append(invoiceLineRow($(this), lotParents, lotChildren[$(this).val()]));
                    return;
                }

                var id = $(this).val();
                var isTitle = $(this).data('is-title');
                var reference = $(this).data('reference');
                var designation = $(this).data('designation');
                var unit = $(this).data('unit');
                var suggestedDeliveryQuantity = $(this).data('suggested-delivery-quantity');
                var originalQuantity = $(this).data('quantity');
                var deliveredQuantity = $(this).data('delivered-quantity');
                var invoicedQuantity = $(this).data('invoiced-quantity');
                var articleId = $(this).data('article_id');
                // Livraison : un véritable article du détail d'un lot semi-détaillé n'affiche pas de quantité
                // (le serveur reprend alors la quantité de la ligne de commande)
                var hidesDeliveryQuantity = type == 'delivery' && $(this).data('lot-detail-article') == 1;
                // Livraison : seule la ligne principale d'un lot est en gras, les autres lignes du lot restent en graisse normale
                var isDeliveryLotMain = type == 'delivery' && $(this).data('lot-main') == 1;
                var isDeliveryLotLine = type == 'delivery' && $(this).data('lot-line') == 1;
                var deliveryDesignation = isDeliveryLotMain
                    ? `<span class="ix-text-bold">${designation}</span>`
                    : designation;
                var titleDesignation = isDeliveryLotMain
                    ? `<span class="ix-text-bold">${designation}</span>`
                    : (isDeliveryLotLine ? designation : `<span class="ix-trade-line-title">${designation}</span>`);
                
                var suggestedQty = suggestedDeliveryQuantity;

                var row = `<tr>
                            <td>
                                <input type="hidden" name="lines[${id}][id]" value="${id}">
                                <input type="hidden" name="lines[${id}][is_title]" value="${isTitle}">
                                <input type="hidden" name="lines[${id}][reference]" value="${reference}">
                                <input type="hidden" name="lines[${id}][designation]" value="${designation}">
                                <input type="hidden" name="lines[${id}][original_quantity]" value="${originalQuantity}">
                                <input type="hidden" name="lines[${id}][unit]" value="${unit}">
                                <input type="hidden" name="lines[${id}][delivered_quantity]" value="${deliveredQuantity}">
                                <input type="hidden" name="lines[${id}][invoiced_quantity]" value="${invoicedQuantity}">
                                <input type="hidden" name="lines[${id}][article_id]" value="${articleId}">
                                ${reference}
                            </td>`

                var isEco = parseInt($(this).data('is-eco')) === 1;

                if (isEco) {
                    // Éco-participation : jamais saisie, sa quantité suit celle de son article
                    const ecoData = `data-eco-parent-line-id="${$(this).data('eco-parent-line-id')}" data-eco-ratio="${$(this).data('eco-ratio')}"`;

                    row += `<td>${deliveryDesignation}</td>
                        <td><span ${ecoData}>0</span></td>
                        <td class="text-center">${originalQuantity} ${unit}</td>
                        <td class="text-center">${deliveredQuantity}</td>
                        <td class="text-center">${invoicedQuantity}</td></tr>`
                } else if (!isTitle && !hidesDeliveryQuantity) {
                   
                    const isReadonly = originalQuantity <= 0 ? 'readonly style="background-color: #e9ecef; pointer-events: none;"' : '';
                    const quantityInput = `<input type="number" class="form-control form-control-sm quantity-input" value="${suggestedQty}" name="lines[${id}][quantity]" required step="0.001" data-line-id="${id}" data-original-quantity="${originalQuantity}" data-invoiced-quantity="${invoicedQuantity}" ${isReadonly}>`;

                    row += `<td>${deliveryDesignation}</td>
                        <td>${quantityInput}</td>
                        <td class="text-center">${originalQuantity} ${unit}</td>
                        <td class="text-center">${deliveredQuantity}</td>
                        <td class="text-center">${invoicedQuantity}</td></tr>`
                } else {
                    row += `<td colspan="5">${titleDesignation}</td></tr>`
                }

                formLinesContainer.append(row)
            })

            syncLotDetailQuantities(formLinesContainer);
            syncEcoFollowQuantities(formLinesContainer);
            formLinesContainer.off('input.ecoFollow').on('input.ecoFollow', '.quantity-input, .percentage-input', function () {
                // Après la mise à jour quantité ↔ pourcentage de la ligne article
                setTimeout(function () {
                    syncLotDetailQuantities(formLinesContainer);
                    syncEcoFollowQuantities(formLinesContainer);
                    if (type == 'invoice') {
                        refreshInvoiceLineAmounts();
                    }
                }, 0);
            });
        } else {
            $('#invoice-lines-body').find($('table')).hide()
            $('#' + modal).find($('.alert')).show()
        }

        // Type de facture (facture, acompte, récurrente) : uniquement pour la modale de facturation
        if (type == 'invoice') {
            $('.select-invoice-type').off('change.invoice_lines').on('change.invoice_lines', function () {
                const selectedType = $(this).val();
                checkboxes.each(function () {
                    const id = $(this).val();
                    const qtyInput = formLinesContainer.find('input[name="lines[' + id + '][quantity]"]');
                    qtyInput.val(selectedType == "1" ? $(this).data('quantity') : $(this).data('suggested-invoice-quantity'));
                    qtyInput.trigger('input');
                });
                updateInvoiceFormState();
            });

            updateInvoiceFormState();

            // Réouverture en facturation à l'avancement (mode pourcentage) : les lignes reconstruites reprennent le pourcentage global
            if ($('#change_type_invoiced').is(':checked') && $('input[name="invoice_mode"]:checked').val() != 'quantity' && $('#global_percentage').val() !== '') {
                applyGlobalPercentage($('#global_percentage'));
            }
        }

        // Gestion du calcul automatique quantité ↔ pourcentage (namespacé : un seul écouteur malgré les ouvertures successives)
        $(document).off('input.processLines', '.percentage-input').on('input.processLines', '.percentage-input', function() {
            if ($(this).is('[readonly]')) return;
            const lineId = $(this).data('line-id');
            const originalQuantity = parseFloat($(this).data('original-quantity')) || 0;
            const percentage = parseFloat($(this).val()) || 0;
            const calculatedQuantity = originalQuantity * percentage / 100;
            // Affiche sans décimales inutiles : 1 au lieu de 1.000
            $(this).closest('form').find(`input[name="lines[${lineId}][quantity]"]`).val(parseFloat(calculatedQuantity.toFixed(3)));
            refreshInvoiceLineAmounts();
        });

        $(document).off('input.processLines', '.quantity-input').on('input.processLines', '.quantity-input', function() {
            const lineId = $(this).data('line-id');
            const originalQuantity = parseFloat($(this).data('original-quantity')) || 0;
            if (originalQuantity == 0) return;
            const quantity = parseFloat($(this).val()) || 0;
            const calculatedPercentage = (quantity / originalQuantity) * 100;
            // Affiche sans décimales inutiles : 50 au lieu de 50.00
            $(this).closest('form').find(`input[name="lines[${lineId}][percentage]"]`).val(parseFloat(calculatedPercentage.toFixed(2)));
            refreshInvoiceLineAmounts();
        });

        $('#' + modal).modal('show');
    }

    $('#create-credit-note-modal').on('click', function (e) {
        e.preventDefault()
        const formLinesContainer = $('#cancelInvoiceModal').find($('.form-lines-container'))
        formLinesContainer.html('')

        // Récupération du nombre de lignes sélectionnées
        const checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));

        if (checkboxes.length > 0) {
            $('#cancelInvoiceModal').find($('table')).show()
            $('#cancelInvoiceModal').find($('.alert')).hide()

            checkboxes.each(function () {
                var id = $(this).val();
                var isTitle = $(this).data('is-title');
                var reference = $(this).data('reference');
                var designation = $(this).data('designation');
                var unit = $(this).data('unit');
                var originalQuantity = $(this).data('quantity');

                var row = `<tr>
                            <td>
                                <input type="hidden" name="lines[${id}][id]" value="${id}">
                                <input type="hidden" name="lines[${id}][is_title]" value="${isTitle}">
                                <input type="hidden" name="lines[${id}][reference]" value="${reference}">
                                <input type="hidden" name="lines[${id}][designation]" value="${designation}">
                                <input type="hidden" name="lines[${id}][original_quantity]" value="${originalQuantity}">
                                <input type="hidden" name="lines[${id}][unit]" value="${unit}">
                                ${reference}
                            </td>`

                if (!isTitle) {
                    row += `<td>${designation}</td>
                        <td>
                            <input type="number" class="form-control form-control-sm" value="${originalQuantity}" name="lines[${id}][quantity]" required step="0.001">
                        </td>
                        <td class="text-center">${originalQuantity} ${unit}</td></tr>`
                } else {
                    row += `<td colspan="3"><span class="ix-trade-line-title">${designation}</span></td></tr>`
                }

                formLinesContainer.append(row)
            })
        } else {
            $('#cancelInvoiceModal').find($('table')).hide()
            $('#cancelInvoiceModal').find($('.alert')).show()
        }

        $('#cancelInvoiceModal').modal('show');
    });

    $('.linked-button').on('click', function (e) {
        $('#' + $(this).data('target')).click();
    });

    $('#rated-clear').on('click', function (e) {
        $(this).css('display', 'none');
        $('#rated-input').val(0);

        $('#rated i.fas.fa-star').removeClass('fas fa-star');
        $('#rated i').addClass('far fa-star');
        e.preventDefault();
    });

    $('.ix-remove-picture-btn').on('click', function (e) {
        var url = $(this).data("url");
        var content = $(this).html();
        $(this).prop("disabled", true);
        $(this).html('<i class="far fa-circle-notch fa-spin"></i> Suppression en cours')

        fetch(url, {
            headers: getHeaders(),
            method: 'DELETE'
        }).then(function (response) {
            if (response.status == 200) {
                response.json().then(function (data) {
                    if (data) {
                        $('.ix-remove-picture-btn').html('<i class="far fa-check"></i> Action réalisée avec succès');
                        $('.ix-open-picture-btn').css('display', 'none');
                        $('.ix-remove-picture-btn').fadeOut(3000);
                        $('#target-remove-picture-preview').hide();
                    }
                })
            } else {
                alertError(null);
                $('.ix-remove-picture-btn').html(content);
                $('.ix-remove-picture-btn').prop("disabled", false);
            }
        }).catch(function (error) {
            alertError(null);
            $('.ix-remove-picture-btn').html(content);
            $('.ix-remove-picture-btn').prop("disabled", false);
        });
        e.preventDefault();
    })



    // Formulaire de création de l'adresse à partir des sociétés
    var addressInput = document.getElementById('address_1') || document.getElementById('modal_address_address_1');
    if (addressInput != null) {
        var zipCodeInput = document.getElementById('zip_code') || document.getElementById('modal_address_zip_code');
        var cityInput = document.getElementById('city') || document.getElementById('modal_address_city');
        var countryInput = document.getElementById('country') || document.getElementById('modal_address_country');
        window.addEventListener('load', getGoogleLocation(addressInput, zipCodeInput, cityInput, countryInput));
    }


});


function calculateTotalRemaining() {
    const checkboxes = $('.check-all-container-lines').find($("input[type=\"checkbox\"]:checked"));
    var totalRemainingTotal = 0;
    if (checkboxes.length > 0) {
        checkboxes.each(function () {
            var remainingTotal = $(this).data('remaining-total');
            totalRemainingTotal += remainingTotal;
        })
    }

    return totalRemainingTotal;
}

/**
 * Modale « Nouvelle facture » (commande) : construction des lignes, calcul des montants comme
 * Line::compute() (pour tomber au centime sur la facture générée), aperçu de l'acompte et récapitulatif
 */

// Arrondi au centime comme PHP round() (demi vers l'extérieur)
function invoiceRound(value) {
    return Math.sign(value) * Math.round(parseFloat((Math.abs(value) * 100).toPrecision(15))) / 100;
}

function invoicePercent(value) {
    return parseFloat((value || 0).toFixed(2)).toLocaleString('fr-FR') + ' %';
}

function invoiceEscape(value) {
    return $('<div>').text(value === undefined || value === null ? '' : String(value)).html().replace(/"/g, '&quot;');
}

// Ligne de la modale à partir de la case cochée de la ligne de commande
function invoiceLineRow(line, lotParents, lotParent) {
    const id = line.val();
    const isTitle = line.data('is-title');
    const designation = invoiceEscape(line.data('designation'));
    const unit = invoiceEscape(line.data('unit'));
    const originalQuantity = line.data('quantity');
    const deliveredQuantity = line.data('delivered-quantity');
    const invoicedQuantity = line.data('invoiced-quantity');
    const suggestedQuantity = line.data('suggested-invoice-quantity');
    const percent = originalQuantity != 0 ? parseFloat(((suggestedQuantity / originalQuantity) * 100).toFixed(2)) : 0;

    const hidden = `<input type="hidden" name="lines[${id}][id]" value="${id}">
        <input type="hidden" name="lines[${id}][is_title]" value="${invoiceEscape(isTitle)}">
        <input type="hidden" name="lines[${id}][reference]" value="${invoiceEscape(line.data('reference'))}">
        <input type="hidden" name="lines[${id}][designation]" value="${designation}">
        <input type="hidden" name="lines[${id}][original_quantity]" value="${originalQuantity}">
        <input type="hidden" name="lines[${id}][unit]" value="${unit}">
        <input type="hidden" name="lines[${id}][delivered_quantity]" value="${deliveredQuantity}">
        <input type="hidden" name="lines[${id}][invoiced_quantity]" value="${invoicedQuantity}">
        <input type="hidden" name="lines[${id}][article_id]" value="${invoiceEscape(line.data('article_id'))}">`;

    const amountCells = (input) => `<td class="text-right" data-amount="unit"></td>
        <td class="text-right" data-amount="total"></td>
        <td class="text-right ix-inv-col-progress" data-amount="invoiced"></td>
        <td class="ix-inv-col-current ix-inv-col-input">${input || ''}</td>
        <td class="text-right ix-inv-col-current ix-inv-current" data-amount="current"></td>
        <td class="text-right ix-inv-col-progress" data-amount="remaining"></td>`;

    // Ligne en option : hors du total de la commande, elle n'est pas facturée (non envoyée)
    if (!isTitle && parseInt(line.data('is-optional')) === 1) {
        return `<tr class="ix-inv-row is-option">
            <td><div class="ix-inv-line"><span class="ix-inv-toggle-space"></span><div class="ix-inv-line-body">
                <div class="ix-inv-name">${designation} <span class="ix-badge optional">Option</span></div>
            </div></div></td>
            <td class="text-right">${originalQuantity} ${unit}</td>
            <td colspan="6" class="ix-inv-muted">Option non retenue — non facturée</td>
        </tr>`;
    }

    // Ligne du détail d'un lot : repliée sous sa ligne principale
    const folded = lotParent ? `data-parent="${lotParent}" style="display: none;"` : '';

    if (isTitle) {
        return `<tr class="ix-inv-row is-title ${lotParent ? 'is-sub-title' : ''}" ${folded}><td colspan="8">${hidden}${designation}</td></tr>`;
    }

    // Éco-participation : jamais saisie, sa quantité suit celle de son article
    if (parseInt(line.data('is-eco')) === 1) {
        const ecoData = `data-eco-parent-line-id="${line.data('eco-parent-line-id')}" data-eco-ratio="${line.data('eco-ratio')}"`;
        return `<tr class="ix-inv-row is-eco ${lotParent ? 'is-composition' : ''}" ${folded}>
            <td>${hidden}<div class="ix-inv-name is-sub">${designation}</div>
                <input type="hidden" class="quantity-input" value="0" name="lines[${id}][quantity]" readonly data-line-id="${id}" data-original-quantity="${originalQuantity}" data-invoiced-quantity="${invoicedQuantity}" ${ecoData}>
            </td>
            <td class="text-right ix-inv-muted">Éco-part.</td>
            ${amountCells()}
        </tr>`;
    }

    // Article de composition d'un lot : ni saisie ni montant, sa quantité suit la ligne principale (repliée par défaut)
    if (line.data('lot-detail-article') == 1) {
        const mainLineId = line.data('lot-main-line-id') || lotParent;
        const quantityField = mainLineId
            ? `<input type="hidden" class="lot-detail-quantity" name="lines[${id}][quantity]" value="${suggestedQuantity}" data-lot-main-line-id="${mainLineId}" data-lot-ratio="${line.data('lot-ratio')}">`
            : `<input type="hidden" name="lines[${id}][quantity]" value="${suggestedQuantity}">`;
        return `<tr class="ix-inv-row is-composition" data-parent="${mainLineId || ''}" ${mainLineId ? 'style="display: none;"' : ''}>
            <td>${hidden}<div class="ix-inv-name is-sub">${designation}</div>${quantityField}</td>
            <td class="text-right ix-inv-muted">${originalQuantity} ${unit}</td>
            <td colspan="6"></td>
        </tr>`;
    }

    // Ligne à 0 : rien à facturer ; ligne négative (remise, reprise) : saisie entre son reste et 0
    const readonly = originalQuantity == 0 ? 'readonly' : '';
    const unitAddon = unit ? `<div class="input-group-append"><span class="input-group-text">${unit}</span></div>` : '';
    const inputs = `<div class="input-group input-group-sm percentage-field">
            <input type="number" class="form-control text-right percentage-input" value="${percent}" name="lines[${id}][percentage]" step="0.01" data-line-id="${id}" data-original-quantity="${originalQuantity}" data-invoiced-quantity="${invoicedQuantity}" ${readonly}>
            <div class="input-group-append"><span class="input-group-text">%</span></div>
        </div>
        <div class="input-group input-group-sm quantity-field">
            <input type="number" class="form-control text-right quantity-input" value="${suggestedQuantity}" name="lines[${id}][quantity]" required step="0.001" data-line-id="${id}" data-original-quantity="${originalQuantity}" data-invoiced-quantity="${invoicedQuantity}" ${readonly}>
            ${unitAddon}
        </div>
        <div class="ix-inv-input-error"></div>`;
    const toggle = lotParents[id]
        ? `<button type="button" class="ix-inv-toggle" data-lot-id="${id}" title="Afficher la composition"><i class="fas fa-caret-right"></i></button>`
        : '<span class="ix-inv-toggle-space"></span>';

    return `<tr class="ix-inv-row is-main">
        <td>
            ${hidden}
            <div class="ix-inv-line">
                ${toggle}
                <div class="ix-inv-line-body">
                    <div class="ix-inv-name">${designation}</div>
                    <div class="ix-inv-progress"><span class="invoiced"></span><span class="current"></span></div>
                    <div class="ix-inv-line-meta"></div>
                </div>
            </div>
        </td>
        <td class="text-right">
            <div>${originalQuantity} ${unit}</div>
            <div class="ix-inv-muted">Livré ${deliveredQuantity} · Facturé ${invoicedQuantity}</div>
        </td>
        ${amountCells(inputs)}
    </tr>`;
}

// Boutons segmentés de la modale : reflètent le champ réel (liste, boutons radio ou case à cocher)
function syncInvoiceSegments() {
    $('#createInvoiceModal .ix-segmented').each(function () {
        const group = $(this);
        const input = $(group.data('input'));
        let value;
        if (input.is('select')) {
            value = input.val();
        } else if (input.is(':radio')) {
            value = input.filter(':checked').val();
        } else {
            value = input.is(':checked') ? group.data('checked-value') : group.data('unchecked-value');
        }
        group.find('button').each(function () {
            $(this).toggleClass('active', String($(this).data('value')) === String(value));
        });
    });
}

// Bouton de validation : bloqué avec la raison affichée à côté, ou actif
function setInvoiceStatus(message) {
    $('#invoice-footer-status').html(message ? '<i class="fas fa-exclamation-circle"></i> ' + message : '');
    $('#invoice-submit-btn').prop('disabled', !!message).toggleClass('disabled', !!message);
}

// Récapitulatif en pied de modale
function renderInvoiceSummary(items) {
    $('#invoice-footer-summary').html(items.map((item, index) => `<div class="ix-inv-sum-item ${index == 0 ? 'is-main' : ''} ${item.strong ? 'is-strong' : ''}">
        <div class="ix-inv-sum-label">${item.label}</div>
        <div class="ix-inv-sum-value">${item.value}${item.note ? ` <small>${item.note}</small>` : ''}</div>
    </div>`).join(''));
}

function invoiceVatRates() {
    return $('#createInvoiceModal .acompte-vat-base').map(function () {
        return {
            rate: parseFloat($(this).data('rate')) || 0,
            base: parseFloat($(this).data('base')) || 0,
            eco: parseFloat($(this).data('eco')) || 0,
        };
    }).get();
}

// Récurrence : rappel du rythme sous les champs
function recurrenceSummary(amountHt) {
    const every = parseInt($('#periodicity').val()) || 1;
    const unit = $('#periodicity_unit option:selected').text().trim().toLowerCase();
    const singular = { 'jours': 'jour', 'semaines': 'semaine', 'mois': 'mois', 'années': 'année', 'ans': 'an' };
    const rhythm = every == 1 ? 'chaque ' + (singular[unit] || unit) : `tous les ${every} ${unit}`;
    const first = $('#first_at').val();
    const cycle = parseInt($('#cycle').val());
    let text = `Une facture de <strong>${formatCurrency(amountHt)} HT</strong> ${rhythm}`;
    if (first) text += `, prochaine échéance le ${invoiceEscape(first)}`;
    text += cycle > 0 ? ` — ${cycle} échéances, soit ${formatCurrency(invoiceRound(amountHt * cycle))} HT au total` : ' — sans fin';
    $('#recurrence-summary').html(text);
}

function refreshInvoiceLineAmounts() {
    const modal = $('#createInvoiceModal');
    if (!modal.length) return;

    const type = $('.select-invoice-type').val();
    if (type == '1') {
        updateAcomptePreview();
        return;
    }

    const isInvoice = type == '0';
    const orderDiscount = parseFloat($('#invoice_order_discount').val()) || 0;
    const totals = { total: 0, invoiced: 0, current: 0, remaining: 0 };
    const draft = { raw: 0, discount: 0, eco: 0, vats: {} };

    modal.find('.form-lines-container tr').each(function () {
        const row = $(this);
        const qtyInput = row.find('.quantity-input');
        if (!qtyInput.length) return;

        const lineId = qtyInput.data('line-id');
        const line = $('.check-all-container-lines input.check-one[value="' + lineId + '"]');
        if (!line.length) return;

        const orderQuantity = parseFloat(line.data('quantity')) || 0;
        const invoicedQuantity = parseFloat(line.data('invoiced-quantity')) || 0;
        const unitPrice = parseFloat(line.data('amount')) || 0;
        const lineDiscount = parseFloat(line.data('discount')) || 0;
        const vatRate = parseFloat(line.data('vat-rate')) || 0;
        const totalHt = parseFloat(line.data('total-ht')) || 0;
        const invoicedHt = parseFloat(line.data('invoiced-total')) || 0;
        const isEco = parseInt(line.data('is-eco')) === 1;
        const isOptional = parseInt(line.data('is-optional')) === 1;
        const quantity = parseFloat(qtyInput.val()) || 0;
        const price = quantity * unitPrice;
        const currentHt = invoiceRound(price - (lineDiscount ? invoiceRound(price / 100 * lineDiscount) : 0));
        const remainingHt = invoiceRound(totalHt - invoicedHt - currentHt);

        // Saisie libre (quantité négative ou au-delà du reste acceptée) : simple indication sous le champ
        const sign = orderQuantity < 0 ? -1 : 1;
        const remainingQuantity = isInvoice ? orderQuantity - invoicedQuantity : orderQuantity;
        const beyond = !isEco && orderQuantity != 0 && (quantity * sign < 0 || quantity * sign > remainingQuantity * sign + 0.0005);
        row.find('.ix-inv-input-error').html(beyond
            ? `<span class="ix-inv-input-note">${quantity * sign < 0
                ? (quantity < 0 ? 'Quantité négative : montant déduit de la facture' : 'Quantité positive : montant ajouté à la facture')
                : (isInvoice ? 'Au-delà du reste à facturer' : 'Au-delà de la quantité commandée')}</span>`
            : '');

        // % en montant, cohérents avec les colonnes (repli sur les quantités pour une ligne à 0 €)
        const invoicedPercent = totalHt != 0 ? invoicedHt / totalHt * 100 : (orderQuantity != 0 ? invoicedQuantity / orderQuantity * 100 : 0);
        const currentPercent = totalHt != 0 ? currentHt / totalHt * 100 : (orderQuantity != 0 ? quantity / orderQuantity * 100 : 0);
        const remainingPercent = 100 - invoicedPercent - currentPercent;
        const cell = key => row.find('[data-amount="' + key + '"]');
        const withPercent = (amount, value) => formatCurrency(amount) + `<div class="ix-inv-muted">${invoicePercent(value)}</div>`;

        cell('unit').html(formatCurrency(unitPrice) + (lineDiscount ? `<div class="ix-inv-muted">Remise ${invoicePercent(lineDiscount)}</div>` : ''));
        cell('total').html(formatCurrency(totalHt));
        cell('invoiced').html(withPercent(invoicedHt, invoicedPercent));
        cell('current').html(formatCurrency(currentHt));
        cell('remaining').html(withPercent(remainingHt, remainingPercent));

        const clamp = value => Math.max(0, Math.min(100, value));
        row.find('.ix-inv-progress .invoiced').css('width', clamp(invoicedPercent) + '%');
        row.find('.ix-inv-progress .current').css('width', clamp(Math.min(currentPercent, 100 - invoicedPercent)) + '%');
        row.find('.ix-inv-line-meta').text(invoicePercent(invoicedPercent) + ' facturé · ' + invoicePercent(currentPercent) + ' cette facture · '
            + invoicePercent(remainingPercent) + ' restant');

        if (isOptional) return;

        totals.total += totalHt;
        totals.invoiced += invoicedHt;
        totals.current += currentHt;
        totals.remaining += remainingHt;

        // Remise globale : jamais sur l'éco-participation
        let base = currentHt;
        if (isEco) {
            draft.eco += currentHt;
        } else {
            const discount = orderDiscount ? invoiceRound(currentHt / 100 * orderDiscount) : 0;
            draft.raw += currentHt;
            draft.discount += discount;
            base = currentHt - discount;
        }
        draft.vats[vatRate] = (draft.vats[vatRate] || 0) + invoiceRound(base / 100 * vatRate);
    });

    const footer = $('#invoice-lines-totals');
    Object.keys(totals).forEach(key => footer.find('[data-total="' + key + '"]').text(formatCurrency(invoiceRound(totals[key]))));

    // Récapitulatif de la facture en cours
    const netHt = invoiceRound(draft.raw - draft.discount);
    const vatItems = [];
    let totalVat = 0;
    Object.keys(draft.vats).sort((a, b) => b - a).forEach(rate => {
        const amount = invoiceRound(draft.vats[rate]);
        totalVat += amount;
        if (amount != 0 || Object.keys(draft.vats).length == 1) {
            vatItems.push({ label: 'TVA ' + invoicePercent(parseFloat(rate)), value: formatCurrency(amount) });
        }
    });
    if (!vatItems.length) vatItems.push({ label: 'TVA', value: formatCurrency(0) });
    const totalTtc = invoiceRound(netHt + draft.eco + totalVat);
    const isRecurrence = type == '2';
    const discountNote = draft.discount ? 'après remise de ' + invoicePercent(orderDiscount) : '';

    const items = [{ label: isRecurrence ? 'Par échéance HT' : 'Cette facture HT', value: formatCurrency(netHt), note: discountNote }];
    if (draft.eco) items.push({ label: 'Éco-participation', value: formatCurrency(invoiceRound(draft.eco)) });
    items.push(...vatItems);
    items.push({ label: isRecurrence ? 'TTC par échéance' : 'Total TTC', value: formatCurrency(totalTtc) });

    if (isRecurrence) {
        recurrenceSummary(netHt);
    } else {
        const deductAcompte = $('#deduct_acompte').is(':checked');
        const acompteTtc = deductAcompte ? parseFloat($('#acompte_total_ttc').val()) || 0 : 0;
        const acompteHt = deductAcompte ? parseFloat($('#acompte_total_ht').val()) || 0 : 0;
        if (acompteTtc > 0) {
            items.push({ label: 'Acompte déduit', value: formatCurrency(-acompteTtc), note: 'TTC' });
            items.push({ label: 'Net à payer TTC', value: formatCurrency(invoiceRound(totalTtc - acompteTtc)), strong: true });
        }
        // Reste à facturer sur les lignes de la commande : les acomptes n'en sont pas retirés,
        // ils sont déduits des factures (affichés à part tant qu'ils ne le sont pas)
        const orderTotal = parseFloat($('#invoice_order_total').val()) || 0;
        const outstandingAcompte = parseFloat($('#invoice_order_acompte_outstanding').val()) || 0;
        const remainingAfter = invoiceRound((parseFloat($('#invoice_order_total_remaining').val()) || 0) + outstandingAcompte - netHt);
        items.push({ label: 'Reste à facturer après', value: formatCurrency(remainingAfter), note: orderTotal ? '(' + invoicePercent(remainingAfter / orderTotal * 100) + ')' : '' });
        const acompteLeft = invoiceRound(outstandingAcompte - acompteHt);
        if (acompteLeft > 0) {
            items.push({ label: 'Acompte restant à déduire', value: formatCurrency(acompteLeft), note: 'HT' });
        }
    }
    renderInvoiceSummary(items);

    // Quantités libres : rien ne bloque la création (efface un éventuel blocage de l'acompte)
    setInvoiceStatus(null);
}

// Acompte : répartition de la commande, aperçu des lignes de la facture d'acompte (comme Order::invoiceLines) et récapitulatif
function updateAcomptePreview() {
    const preview = $('#acompte-preview');
    if (!preview.length) return;

    const isAmount = $('#acompte_mode_hidden').val() === 'amount';
    const orderNumber = preview.data('order-number') || '';
    const orderTotal = parseFloat($('#invoice_order_total').val()) || 0;
    const invoiced = parseFloat($('#invoice_order_invoiced').val()) || 0;
    const orderTtc = parseFloat($('#acompte_order_total_ttc').val()) || 0;
    const amount = parseFloat($('#acompte_amount').val()) || 0;
    const percent = isAmount ? (orderTtc > 0 ? amount / orderTtc * 100 : 0) : (parseFloat($('#percent').val()) || 0);

    const designation = isAmount
        ? 'Acompte de ' + formatCurrency(amount) + ' TTC sur la commande n°' + invoiceEscape(orderNumber)
        : 'Acompte de ' + invoicePercent(percent) + ' sur la commande n°' + invoiceEscape(orderNumber);

    const rates = invoiceVatRates();
    let acompteHt = 0;
    let ecoHt = 0;
    const vats = {};
    const rows = [];

    rates.forEach(item => {
        const base = item.base - item.eco;
        const lineHt = invoiceRound(base * percent / 100);
        const ecoLine = invoiceRound(item.eco * percent / 100);
        acompteHt += lineHt;
        ecoHt += ecoLine;
        vats[item.rate] = (vats[item.rate] || 0) + invoiceRound(lineHt * item.rate / 100) + invoiceRound(ecoLine * item.rate / 100);
        rows.push(`<tr>
            <td><div class="ix-inv-name">${designation}${rates.length > 1 ? ' <span class="ix-inv-muted">— TVA ' + invoicePercent(item.rate) + '</span>' : ''}</div>
                <div class="ix-inv-muted">Déductible des factures suivantes de la commande</div></td>
            <td class="text-right">${formatCurrency(base)}</td>
            <td class="text-right ix-inv-col-current ix-inv-current">${formatCurrency(lineHt)}</td>
        </tr>`);
    });

    if (ecoHt) {
        rows.push(`<tr>
            <td><div class="ix-inv-name">Éco-participation</div></td>
            <td class="text-right">${formatCurrency(rates.reduce((sum, item) => sum + item.eco, 0))}</td>
            <td class="text-right ix-inv-col-current ix-inv-current">${formatCurrency(ecoHt)}</td>
        </tr>`);
    }

    acompteHt = invoiceRound(acompteHt);
    // Plafond : l'acompte ne peut pas dépasser ce qui reste à facturer sur la commande
    const available = invoiceRound(orderTotal - invoiced);
    const exceeds = acompteHt > available + 0.005;
    const rest = Math.max(0, invoiceRound(available - acompteHt));
    const share = value => orderTotal ? value / orderTotal * 100 : 0;
    const clamp = value => Math.max(0, Math.min(100, value));

    // Déjà facturé = factures + acomptes pas encore déduits (affichés à part)
    const previousAcompte = Math.min(invoiced, parseFloat($('#invoice_order_acompte_outstanding').val()) || 0);
    const billed = invoiceRound(invoiced - previousAcompte);
    $('#acompte-split-invoiced').css('width', clamp(share(billed)) + '%');
    $('#acompte-split-previous').css('width', clamp(share(previousAcompte)) + '%');
    $('#acompte-split-current').css('width', clamp(Math.min(share(acompteHt), 100 - share(invoiced))) + '%');
    $('#acompte-legend-invoiced-item').toggle(billed > 0);
    $('#acompte-legend-previous-item').toggle(previousAcompte > 0);
    $('#acompte-legend-invoiced').text(formatCurrency(billed) + ' (' + invoicePercent(share(billed)) + ')');
    $('#acompte-legend-previous').text(formatCurrency(previousAcompte) + ' (' + invoicePercent(share(previousAcompte)) + ')');
    $('#acompte-legend-current').text(formatCurrency(acompteHt) + ' (' + invoicePercent(share(acompteHt)) + ')');
    $('#acompte-legend-rest').text(formatCurrency(rest) + ' (' + invoicePercent(share(rest)) + ')');

    const empty = percent <= 0;
    // Maximum : le reste à facturer, en % du total HT ou en TTC
    let maxPercent = Math.max(0, Math.round(share(available) * 100) / 100);
    if (invoiceRound(orderTotal * maxPercent / 100) > available + 0.005) {
        maxPercent = Math.max(0, Math.floor(share(available) * 100) / 100);
    }
    const maxAmount = Math.max(0, Math.floor(available / (orderTotal || 1) * orderTtc * 100) / 100);
    $('#percent, #acompte_amount').toggleClass('is-invalid', exceeds);
    $('#acompte-percent-max').html(exceeds && !isAmount ? `Max ${invoicePercent(maxPercent)} (${formatCurrency(Math.max(0, available))} HT) <a class="ix-inv-fix-acompte" data-value="${maxPercent}">Appliquer</a>` : '');
    $('#acompte-amount-max').html(exceeds && isAmount ? `Max ${formatCurrency(maxAmount)} TTC <a class="ix-inv-fix-acompte" data-value="${maxAmount}">Appliquer</a>` : '');
    setInvoiceStatus(exceeds
        ? 'L\'acompte dépasse le reste à facturer de la commande'
        : (empty ? (isAmount ? 'Saisissez le montant de l\'acompte' : 'Saisissez le pourcentage de l\'acompte') : null));
    $('#acompte-empty-message').toggle(empty);
    $('#acompte-totals').toggle(!empty);
    $('#acompte-lines').html(rows.join(''));

    let totalVat = 0;
    const items = [{ label: 'Cet acompte HT', value: formatCurrency(acompteHt) }];
    if (ecoHt) items.push({ label: 'Éco-participation', value: formatCurrency(ecoHt) });
    Object.keys(vats).sort((a, b) => b - a).forEach(rate => {
        totalVat += vats[rate];
        items.push({ label: 'TVA ' + invoicePercent(parseFloat(rate)), value: formatCurrency(invoiceRound(vats[rate])) });
    });
    items.push({ label: 'Total TTC', value: formatCurrency(invoiceRound(acompteHt + ecoHt + totalVat)) });

    // Aide à côté du champ : ce qui reste à facturer tant que rien n'est saisi, puis l'équivalence de la saisie
    const acompteTtc = invoiceRound(acompteHt + ecoHt + totalVat);
    const availableHint = 'Reste à facturer : <strong>' + formatCurrency(Math.max(0, available)) + ' HT</strong> (' + invoicePercent(maxPercent) + ' max)';
    $('#acompte-percent-hint').html(empty || isAmount ? availableHint : '= <strong>' + formatCurrency(acompteHt) + ' HT</strong> · ' + formatCurrency(acompteTtc) + ' TTC');
    $('#acompte-amount-hint').html(empty || !isAmount ? availableHint : '= <strong>' + invoicePercent(percent) + '</strong> · ' + formatCurrency(acompteHt) + ' HT');
    items.push({ label: 'Reste à facturer HT', value: formatCurrency(rest), note: '(' + invoicePercent(share(rest)) + ')' });
    renderInvoiceSummary(items);
}

function updateTextTotalRemaining() {
    if($('#total-ht-block').length){
        var value = $('#percent').length ? $('#percent').val() : 100;
        var totalRemainingTotal = calculateTotalRemaining();
        var finalRenderValue = ((value * totalRemainingTotal) / 100).toFixed(2);
        $('#invoice_total_ht').text(formatCurrency(finalRenderValue));
    }
}

function disableButtonAndLoad(button) {
    button.data('original', button.html())
    button.html('<i class="far fa-circle-notch fa-spin"></i>');
    button.prop("disabled", true);
    button.addClass("disabled");
}

function resetButtonAfterLoad(button) {
    button.html(button.data('original'));
    button.prop("disabled", false);
    button.removeClass("disabled");
}


/**
 * Désactivation du bouton de soumission du formulaire
 * @param form
 */
function disableSubmitButton(form) {
    var submitCallAction = $(form).find(':submit');
    submitCallAction.html('<i class="far fa-circle-notch fa-spin"></i>');
    submitCallAction.prop("disabled", true);
    submitCallAction.addClass("disabled");
    $(form).addClass('submitted');
}

/**
 * Confirmation avant suppression
 *
 * https://github.com/sweetalert2/sweetalert2
 */

function confirmDelete(e) {
    e.preventDefault();
    let message = $(this).data('message');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: message ? message : "Vous ne pourrez pas revenir en arrière",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#D15240',
        confirmButtonText: 'Oui, supprimer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            if ($(this).is('a')) {
                window.location.href = $(this).attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}

function confirmDeletePreventive(e) {
    e.preventDefault();
    let message = $(this).data('message');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: message ? message : "Les OT associés ainsi que les rapports d'interventions seront également supprimés",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#D15240',
        confirmButtonText: 'Oui, supprimer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            if ($(this).is('a')) {
                window.location.href = $(this).attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}


function confirmAcceptCreateQuote(e) {
    if ($('#create_new_deal_true:checked').length > 0) {
        e.preventDefault();
        let message = $(this).data('message');
        let self = $(this);
        Swal.fire({
            title: 'Etes vous sûrs de vouloir créer une nouvelle affaire ?',
            text: message ? message : "Ce choix sera irréversible.",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#D15240',
            confirmButtonText: 'Oui, créer',
            reverseButtons: true,
            heightAuto: false
        }).then((result) => {
            if (result.value) {
                if ($(self).is('a')) {
                    window.location.href = $(self).attr('href')
                } else {
                    disableSubmitButton(self)
                    self.submit()
                }
            }
        })
    }
}


function confirmCloseInspection(e) {
    e.preventDefault();

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: "En fermant cet ordre de travail, tous les rapports d'interventions associées passeront à l'état 'terminé'",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonColor: '#D15240',
        confirmButtonText: 'Oui, fermer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            if ($(this).is('a')) {
                window.location.href = $(this).attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}

/**
 * Confirmation avant duplication
 *
 */

function confirmDuplicate(e) {
    e.preventDefault();

    var form = $(this);

    /**
     * Option « Dupliquer également les documents ».
     *
     * Elle n'apparaît que sur les écrans qui déclarent data-documents-count,
     * c'est-à-dire aujourd'hui l'étude et le devis. Les autres écrans portant
     * .duplicate-form (formulaires, articles, dépenses, missions, groupes de
     * prestations, rôles) n'ont pas cet attribut et conservent donc la modale
     * à l'identique.
     *
     * Le compteur ne porte que sur les documents PROPRES de l'élément : ceux
     * qu'il se contente d'afficher parce qu'ils appartiennent à un élément lié
     * ne sont ni comptés ni copiés.
     *
     * Option « Dupliquer les dilutions de frais généraux » : uniquement sur
     * l'étude, quand data-overhead-dilutions-count indique au moins une
     * dilution enregistrée. Décochée à chaque ouverture : la case est recréée
     * avec la modale.
     */
    var documentsCount = parseInt(form.data('documents-count') || 0, 10);
    var overheadDilutionsCount = parseInt(form.data('overhead-dilutions-count') || 0, 10);
    var commentsCount = parseInt(form.data('comments-count') || 0, 10);
    var elementLabel = form.data('element-label') || 'cet élément';
    var message = "Vous devrez disposer des permissions de modifications afin de modifier la copie de cet élément";
    var options = {
        title: 'Êtes-vous sûr ?',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Dupliquer',
        reverseButtons: true,
        heightAuto: false
    };

    var choices = '';

    if (documentsCount > 0) {
        var documentsLabel = documentsCount > 1
            ? 'les ' + documentsCount + ' documents'
            : 'le document';

        choices += '<div class="custom-control custom-checkbox">'
            +         '<input type="checkbox" class="custom-control-input" id="duplicateDocumentsCheck">'
            +         '<label class="custom-control-label" for="duplicateDocumentsCheck">Dupliquer également ' + documentsLabel + '</label>'
            +     '</div>'
            +     '<small class="ix-text-secondary d-block mt-1">Les documents propres à ' + elementLabel + ' seront également copiés dans la nouvelle version.</small>';
    }

    // Option « Dupliquer les commentaires » : auteur et date d'origine conservés
    if (commentsCount > 0) {
        var commentsLabel = commentsCount > 1
            ? 'les ' + commentsCount + ' commentaires'
            : 'le commentaire';

        choices += '<div class="custom-control custom-checkbox' + (choices ? ' mt-3' : '') + '">'
            +         '<input type="checkbox" class="custom-control-input" id="duplicateCommentsCheck">'
            +         '<label class="custom-control-label" for="duplicateCommentsCheck">Dupliquer également ' + commentsLabel + '</label>'
            +     '</div>'
            +     '<small class="ix-text-secondary d-block mt-1">Les commentaires de ' + elementLabel + ' seront copiés avec leur auteur et leur date.</small>';
    }

    if (overheadDilutionsCount > 0) {
        choices += '<div class="custom-control custom-checkbox' + (choices ? ' mt-3' : '') + '">'
            +         '<input type="checkbox" class="custom-control-input" id="duplicateOverheadDilutionsCheck">'
            +         '<label class="custom-control-label" for="duplicateOverheadDilutionsCheck">Dupliquer également les dépenses et leur répartition</label>'
            +     '</div>'
            +     '<small class="ix-text-secondary d-block mt-1">Les dépenses réparties propres à ' + elementLabel + ' seront également copiées dans la nouvelle version.</small>';
    }

    if (choices) {
        options.html = message + '<div class="text-left mt-4">' + choices + '</div>';

        // Lecture avant la fermeture de la modale : son DOM n'existe plus
        // dans le then().
        options.preConfirm = function () {
            var documentsCheckbox = document.getElementById('duplicateDocumentsCheck');
            var overheadDilutionsCheckbox = document.getElementById('duplicateOverheadDilutionsCheck');
            var commentsCheckbox = document.getElementById('duplicateCommentsCheck');

            form.find('input[name="duplicate_documents"]').val(documentsCheckbox && documentsCheckbox.checked ? 1 : 0);
            form.find('input[name="duplicate_overhead_dilutions"]').val(overheadDilutionsCheckbox && overheadDilutionsCheckbox.checked ? 1 : 0);
            form.find('input[name="duplicate_comments"]').val(commentsCheckbox && commentsCheckbox.checked ? 1 : 0);

            return true;
        };
    } else {
        options.text = message;
    }

    Swal.fire(options).then((result) => {
        // isConfirmed et non value : avec une case décochée, preConfirm peut
        // renvoyer une valeur falsy et le formulaire ne serait jamais soumis.
        if (result.isConfirmed) {
            if (form.is('a')) {
                window.location.href = form.attr('href')
            } else {
                disableSubmitButton(this)
                this.submit()
            }
        }
    })
}

/**
 * Confirmation avant action
 */

function confirmForm(e) {
    e.preventDefault();
    let message = $(this).data('message');
    let actionText = $(this).data('action-text');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: message ? message : "Vous ne pourrez pas revenir en arrière",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: actionText ? actionText : 'Confirmer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            disableSubmitButton(this)
            this.submit()
        }
    })
}

/**
 * Confirmation avant action
 */

function confirmFormDealUnClosed(e) {
    e.preventDefault();
    let message = $(this).data('message');
    let actionText = $(this).data('action-text');

    Swal.fire({
        title: 'Êtes-vous sûr ?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: actionText ? actionText : 'Confirmer',
        reverseButtons: true,
        heightAuto: false
    }).then((result) => {
        if (result.value) {
            disableSubmitButton(this)
            this.submit()
        }
    })
}


/**
 * Alert erreur
 */
function alertError(message) {
    Swal.fire({
        title: 'Erreur',
        text: message ? message : "Une erreur s'est produite. Veuillez contacter votre administrateur",
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'Ok',
        reverseButtons: true,
        heightAuto: false
    })
}

/**
 * Format monétaire
 */
function formatCurrency(val) {
    var amount = parseFloat(val);
    amount = amount.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
    amount += "€";

    return amount
}

/**
 * Récupération des headers commun
 */
function getHeaders() {
    return {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        'Accept': 'application/json',
        'Authorization': `Bearer ${API_TOKEN}`
    }
}

/**
 * Scroll au bloc
 */
function scrollToAnchor(id) {
    var el = $("#" + id);
    if (el) {
        $('html,body').animate({ scrollTop: el.offset().top }, 'slow');
    }
}

function getGoogleLocation(mainInput, zipCodeInput = null, cityInput = null, countryInput = null) {

    var autocomplete = new google.maps.places.Autocomplete(mainInput, {
        componentRestrictions: { 'country': ['FR'] },
        fields: ['place_id', 'name', 'address_components']
    });


    autocomplete.addListener('place_changed', function () {
        let zipCode, city, country = null;
        var place = autocomplete.getPlace();
        mainInput.value = place.name;

        place?.address_components?.forEach(entry => {
            if (entry.types?.[0] == "postal_code") {
                zipCode = entry.long_name;
            }
            if (entry.types?.[0] == "locality") {
                city = entry.long_name;
            }
            if (entry.types?.[0] == "country") {
                country = entry.short_name;
            }

        })

        if (zipCodeInput != null) {
            zipCodeInput.value = zipCode != null ? zipCode : '';
        }
        if (cityInput != null) {
            cityInput.value = city != null ? city : '';
        }
        if (countryInput != null) {
            countryInput.value = country != null ? country : '';
        }
    });

}

/* Vue JS component */
Vue.mixin({
    methods: {
        getHttpJsonRequestHeaders: function (isFormData = false) {
            var headers = getHeaders();

            if (isFormData) {
                delete headers['Content-Type']
            }

            const data = {
                credentials: 'same-origin',
                headers: headers
            }

            return data
        },
        currency: function (val) {
            return formatCurrency(val)
        },
        /**
         * Rendu d'une suggestion d'étude / prestation : ligne article (PAMP ou fournisseur
         * favori) puis une ligne indentée par tarif fournisseur.
         */
        studySuggestionItemHtml: function (item) {
            if (item.is_child) {
                var label = item.provider
                    ? `Vendu par ${item.provider} ${item.is_favorite ? '<span class="ix-text-yellow"><i class="far fa-star"></i></span>' : ''} ${item.provider_reference ? '- ' + item.provider_reference : ''} ${item.indications ? '- ' + item.indications : ''}`
                    : `${item.price_label} <span class="text-muted">(moyenne des achats sur 12 mois)</span>`

                return `<div class="d-flex align-items-center ix-text-small ix-suggestion-small">
                            <span><i class="far fa-level-up fa-rotate-90"></i> ${label}</span>
                            <span class="ml-auto">${item.formatted_amount}</span>
                        </div>`
            }

            var html = `<div class="d-flex align-items-center">
                            <span class="badge badge-secondary">${item.category}</span>
                            <span class="ml-2">${item.autocomplete_label}</span>`

            if (item.is_title) {
                html += `</div>`
            } else {
                html += `<span class="ml-auto">${item.price_label ? '<span class="ix-text-small text-muted mr-2">' + item.price_label + '</span>' : ''}${item.formatted_amount}</span>
                        </div>`
            }

            return html
        },
        formatHours: function (decimalHours) {
            if (decimalHours === null || decimalHours === undefined || decimalHours === '') {
                return '-';
            }
            const h = Math.floor(decimalHours);
            const m = Math.round((decimalHours - h) * 60);
            if (m === 0) return `${h}h`;
            return `${h}:${m.toString().padStart(2, '0')}`;
        },
        nl2br(str, is_xhtml) {
            var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        },
        truncate(str, n) {
            return (str.length > n) ? str.substr(0, n - 1
            ) + '&hellip;' : str;
        },
        roundCurrency(num, places) {
            return +(Math.round(num + "e+" + places) + "e-" + places);
        },
        moment: function (date = null) {
            return date ? moment(date) : moment();
        },
        momentFromFormat: function (date, format) {
            return moment(date, format);
        },
        searchInUrl: function (param) {
            var tmp = [];
            var result = null;

            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    tmp = item.split("=");
                    if (tmp[0] == param) {
                        result = tmp.length > 1 ? tmp[1] : true
                    }
                });

            return result;
        },
        __: function (key, replace = {}) {
            // Fonction de traduction Laravel pour Vue
            let translation = key.split('.').reduce((t, i) => t[i] || null, window.translations || {});
            
            if (!translation) {
                return key;
            }

            // Remplacer les placeholders :key par les valeurs
            Object.keys(replace).forEach(function (key) {
                translation = translation.replace(':' + key, replace[key]);
            });

            return translation;
        }
    }
})

Vue.filter('formatDate', function (value, format) {
    if (value) {
        return moment(String(value)).format(format ? format : 'DD MMM YYYY - HH:mm')
    }
});

Vue.filter('formatFileSize', function (value, dp = 0) {
    if (value) {
        //const thresh = si ? 1000 : 1024;
        const thresh = 1000;

        if (Math.abs(value) < thresh) {
            return value + ' B';
        }

        const units = ['ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];
        let u = -1;
        const r = 10 ** dp;

        do {
            value /= thresh;
            ++u;
        } while (Math.round(Math.abs(value) * r) / r >= thresh && u < units.length - 1);


        return value.toFixed(dp) + ' ' + units[u];
    }
})

var vm = new Vue({
    el: '#app',
    data: {
        store: {
            forms: [],
            activeForm: [],
            activeModalFormBuilder: false,
            element: null,
            indexModal: null,
            formIsValid: true,
            formMode: '',
        },
    },
    components: {
        GenericMultiSelect,
        QuoteAcceptance,
        UsersStatistics,
        TradeEvolution,
        ClientBalance,
        DebtorsRank,
        FiltersSummary,
        Comments,
        LineTableForm,
        LineForm,
        VueTypeaheadBootstrap,
        Sendings,
        BonusSelector,
        ExpenseReportLineTableForm,
        ExpenseReportLineForm,
        Signatures,
        SignaturesReceptions,
        DocumentsManagerModal,
        DocumentsManager,
        BillPaymentOrderSelector,
        AbsencesTable,
        AbsencesTableModal,
        ArticleProviderTableForm,
        ArticleProviderForm,
        ArticleAttributeForm,
        PurchaseTableForm,
        PurchaseForm,
        ExpenseBillSelector,
        Elements,
        DisplayFormBuilder,
        RenderFormBuilder,
        UserSelector,
        ArticleSelector,
        ArticleDealsSummary,
        ReceptionsValuationSummary,
        CheckingForm,
        InitScanCheckingForm,
        ProviderBalance,
        CheckingsTable,
        PredictionTableForm,
        PredictionForm,
        DeliveryLineTableForm,
        DeliveryLineForm,
        IndicatorsArray,
        DealProgress,
        ContractsStatistics,
        VatsArray,
        CompanySelector,
        CompanyPennylaneSync,
        InvoicePennylaneSync,
        CreditNotePennylaneSync,
        InvoiceValidationModal,
        AccountingAccountsAffectation,
        TasksTable,
        SubtasksManager,
        QuickNote,
        UserNotification,
        PhoneNumber,
        PriceForm,
        BillTotalsForm,
        OperationTableForm,
        OperationForm,
        DealLotOperation,
        SchedulesKanban,
        SchedulesSingle,
        SpendingEvolution,
        PrecheckingsTable,
        PrecheckingsForm,
        Note,
        CustomEditor,
        BankEvolution,
        PaymentComponent,
        PayableLine,
        ActivityPies,
        Counter,
        MapComponent,
        TriggerComponent,
        PlanningTable,
        FormPlanningComponent,
        SyncOperation,
        CheckingMaintenanceForm,
        CreateInspectionComponent,
        PlanningTableModal,
        DealLotProgress,
        EditPredictionTable,
        SendingModalComponent,
        GroupOrders,
        InjectStudy,
        QuoteVersioning,
        AcceptQuoteVersionning,
        ServiceListTableForm,
        ServiceListForm,
        TradeStatistics,
        ChronoComponent,
        BillCreditSupplierForm,
        BillInboxSidebar,
        AccountingAccountGeneration,
        DiscountTrade,
        BookingLotArticleForm,
        BookingLotArticleLine,
        BookingArticleLine,
        BookingModal,
        ArticleProgressStock,
        BookingArticleTable,
        ArticleEcoTaxForm,
        AutoFormSaveComponent,
        EquipmentStationTable,
        PrecheckingsInterventionForm,
        PrecheckingsInterventionTable,
        GroupDeliveries
    },
});


global.vm = vm;

window.limitTextarea = function(el, maxLines, maxCharsPerLine) {
    el.addEventListener('input', function() {
        var lines = el.value.split('\n');
        var newLines = [];
        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            while (line.length > maxCharsPerLine && newLines.length < maxLines) {
                newLines.push(line.substring(0, maxCharsPerLine));
                line = line.substring(maxCharsPerLine);
            }
            if (newLines.length < maxLines) {
                newLines.push(line);
            }
        }
        if (newLines.length > maxLines) {
            newLines = newLines.slice(0, maxLines);
        }
        el.value = newLines.join('\n');
    });
    el.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            var lines = el.value.split('\n');
            if (lines.length >= maxLines) {
                e.preventDefault();
                return false;
            }
        }
    });
};
